let productsData={};
var pageLoad = 1;
(async function () {

    // Utils
    const Utils = {};

    Utils.resetFilterBubbles = () => {
        document
            .querySelectorAll("filter-bubble")
            .forEach((filterBubble) => filterBubble.remove());
    };

    Utils.getAllQueryParams = () => {
        const queryParams = new URLSearchParams(window.location.search);
        const paramsObj = {};
        queryParams.forEach((value, key) => {
            paramsObj[key] = value;
        });
        return paramsObj;
    };

    Utils.getQueryParam = (param) => {
        const queryParams = new URLSearchParams(window.location.search);
        return queryParams.get(param);
    };

    Utils.setQueryParam = (param, value) => {
        const queryParams = new URLSearchParams(window.location.search);
        const currentParamValue = Utils.getQueryParam(param);
        if (
            currentParamValue &&
            !param.includes("sort_by") &&
            !param.includes("filter.v.price")
        ) {
            const paramValuesArr = currentParamValue.split(",");
            paramValuesArr.push(value);
            queryParams.set(param, paramValuesArr.join(","));
        } else {
            queryParams.set(param, value);
        }
        const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
        history.pushState(null, null, newUrl);
        Utils.resetFilterBubbles();
        if (param.includes("filter.v.price")) {
            // Make sure that's only called once
            if (param === "filter.v.price.max") {
                window.dispatchEvent(paramChangeEvent);
            }
        } else {
            window.dispatchEvent(paramChangeEvent);
        }
    };

    Utils.removeQueryParam = (param, value) => {
        const queryParams = new URLSearchParams(window.location.search);
        let queryParamValues = [];
        const paramValues = Utils.getQueryParam(param);

        if (paramValues) {
            queryParamValues = paramValues.split(",");
            if (queryParamValues.length <= 1) {
                queryParams.delete(param);
            } else {
                const matchedFilterValueIndex = queryParamValues.findIndex(
                    (filterValue) => filterValue === value
                );
                queryParamValues.splice(matchedFilterValueIndex, 1);
                queryParams.set(param, queryParamValues.join(","));
            }
        }

        const newUrl = window.location.pathname + "?" + queryParams.toString();
        history.pushState(null, null, newUrl);
        Utils.resetFilterBubbles();
        window.dispatchEvent(paramChangeEvent);
    };

    Utils.resetQueryParam = (param) => {
        const url = new URL(window.location.href);
        url.searchParams.delete(param);
        window.history.replaceState(null, null, url);
    };

    Utils.formatFilterQuery = (filterStr) => {
        const replacements = {
            '"filters":': "filters:",
            '"variantOption"': "variantOption",
            '"name"': "name",
            '"value"': "value",
            '"available"':"available",
            "{filters": "filters",
            "]}": "]",
            '"namespace"': "namespace",
            '"key"': "key",
            '"productMetafield"': "productMetafield",
            '"price"': "price",
            '"min":"': "min:",
            '","max":"': ",max:",
            // '0"': "0",
            // '1"': "1",
            // '2"': "2",
            // '3"': "3",
            // '4"': "4",
            // '5"': "5",
            // '6"': "6",
            // '7"': "7",
            // '8"': "8",
            // '9"': "9",
            // '10"': "10",
        };
        return Object.entries(replacements).reduce(
            (acc, [pattern, replacement]) => acc.replaceAll(pattern, replacement),
            filterStr
        );
    };

    Utils.setImageUrlWidth = (imageUrl, width) => {
        const newImageUrl = `${imageUrl}&width=${width}`;
        return newImageUrl;
    };

    Utils.formatMoney = (value) => {
        const cents = value * 100;
        const format = "${{amount}}";
        if (format == null || format == undefined) {
            format = window.globalVariables.money_format || "${{ amount }}";
        }
        if (typeof cents == "string") {
            cents = cents.replace(".", "");
        }
        var value = "";
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = format || this.money_format;
        function defaultOption(opt, def) {
            return typeof opt == "undefined" ? def : opt;
        }
        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2);
            thousands = defaultOption(thousands, ",");
            decimal = defaultOption(decimal, ".");
            if (isNaN(number) || number == null) {
                return 0;
            }
            number = (number / 100.0).toFixed(precision);
            var parts = number.split("."),
                dollars = parts[0].replace(
                    /(\d)(?=(\d\d\d)+(?!\d))/g,
                    "$1" + thousands
                ),
                cents = parts[1] ? decimal + parts[1] : "";
            return dollars + cents;
        }
        switch (formatString.match(placeholderRegex)[1]) {
            case "amount":
                value = formatWithDelimiters(cents, 2);
                break;
            case "amount_no_decimals":
                value = formatWithDelimiters(cents, 0);
                break;
            case "amount_with_comma_separator":
                value = formatWithDelimiters(cents, 2, ".", ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                value = formatWithDelimiters(cents, 0, ".", ",");
                break;
        }
        return formatString.replace(placeholderRegex, value);
            // .replace(".00", "");
    };

    Utils.getOffPercetange = (compareAtPrice, price) => {
        const offPercentage =
            100 - (parseFloat(price) / parseFloat(compareAtPrice)) * 100;
        return Math.round(offPercentage);
    };

    Utils.formatProductId = (productId) => {
        return productId.replaceAll("gid://shopify/Product/", "");
    };

    Utils.formatVariantId = (variantId) => {
        return variantId.replaceAll("gid://shopify/ProductVariant/", "");
    };

    Utils.formatSellingPlanId = (sellingPlanId) => {
        return sellingPlanId.replaceAll("gid://shopify/SellingPlan/", "");
    };

    Utils.capitalizeStr = (str) => {
        const capitalizeWords = str.replace(/\b\w/g, (letter) =>
            letter.toUpperCase()
        );
        return capitalizeWords;
    };

    Utils.handleize = (str) => {
        return str.toLowerCase()
            .replace(/[^\w\s-]/g, '') // Remove non-word characters, spaces, and hyphens
            .replace(/[\s_-]+/g, '-') // Replace spaces and underscores with hyphens
            .replace(/^-+|-+$/g, ''); // Trim leading and trailing hyphens
    }

    // GraphQL Query
    const useQuery = async (query) => {
        const queryResponse = await fetch("/api/graphql.json", {
            method: "POST",
            headers: {
                "Content-Type": "application/graphql",
                "Access-Control-Origin": "*",
                "X-Shopify-Storefront-Access-Token": "919d576e808af70151b52470924f6a99",
            },
            body: query,
        });

        return await queryResponse.json();
    };

    Utils.addVariantToCart = async (variantId, sellingPlanId = null) => {
        const parsedVariantId = parseInt(variantId);
        const itemObj = {
            id: parsedVariantId,
            quantity: 1,
        };

        if (sellingPlanId) {
            const parsedSellingPlanId = parseInt(sellingPlanId);
            itemObj.properties = {
                _main_subscription: true,
            };
            itemObj.selling_plan = parsedSellingPlanId;
        } else {
            itemObj.properties = {
                _main_subscription: false,
            };
        }
        if (window.customerDetails?.customerTags.includes('Active Subscriber') || window.customerDetails?.customerTags.includes('REAL_ACTIVE_SUBSCRIBER')) {
            itemObj.properties['_active_subscriber'] = true;
        }
        const cartResponse = await fetch(
            window.Shopify.routes.root + "cart/add.js",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    items: [itemObj],
                }),
            }
        );

        // Remove quickbuys
        document.querySelectorAll('quick-buy').forEach(quickBuy => quickBuy.remove());
        html.classList.remove('open');


            if (Zowie) {
                console.log('Zowie event fired ------------')
                Zowie.updateCart()
            }

        return await cartResponse.json();
    };

    Utils.getListFilterSwatchOld = (filterDetails, value) => {
        const filterValueLabel = document.createElement("label");
        const currentParamValue = Utils.getQueryParam(filterDetails.id);
        if (currentParamValue) {
            const currentParamValueArr = currentParamValue.split(",");
            if (currentParamValueArr.includes(value.label)) {
                filterValueLabel.classList.add("active");
            }
        }
        filterValueLabel.classList.add("filter-swatch");
        filterValueLabel.setAttribute('role', 'button');
        filterValueLabel.dataset.filterId = filterDetails.id;
        if (filterDetails.id.includes("color")) {
            filterValueLabel.classList.add("filter-color");
            // Use value label's to set a fixed order among the filter swatches
            filterValueLabel.style.order = value.label.length;
            const swatchCircle = document.createElement("div");
            swatchCircle.classList.add("swatch-circle");

            swatchCircle.innerHTML = `<span class="hide">${value.label}</span>`;
            const matchedColorSetting = filterColorSettings.find(
                (color) => color.colorName.toLowerCase() === value.label.toLowerCase()
            );
            if (matchedColorSetting) {
                swatchCircle.style.backgroundColor = matchedColorSetting.colorHexValue;
            } else {
                const baseUrl = document.querySelector('[data-file-url-base]').dataset.fileUrlBase;
                const swatchUrl = baseUrl.replace('multi', value.label.toLowerCase().replaceAll(' ', '-')).replace('127.0.0.1:9292', 'woxer.com');
                swatchCircle.style.backgroundImage = `url(${Utils.setImageUrlWidth(swatchUrl, 31)})`;
            }
            filterValueLabel.append(swatchCircle);
        }

        filterValueLabel.addEventListener("click", () => {
            const filterParam = Utils.getQueryParam(filterDetails.id);
            let filterParamsArr = [];
            if (filterParam) {
                filterParamsArr = filterParam.split(",");
            }
            // Extract filter value from ID
            const filterValue = filterValueLabel.dataset.value;

            if (filterParamsArr.includes(filterValue)) {
                Utils.removeQueryParam(filterDetails.id, filterValue);
            } else {
                Utils.setQueryParam(filterDetails.id, filterValue);
            }
        });

        const labelText = document.createElement("span");
        labelText.innerText = value.label;
        filterValueLabel.title = value.label;
        filterValueLabel.append(labelText);
        filterValueLabel.dataset.value = value.label;

        return filterValueLabel;
    };

    Utils.getListFilterSwatch = (filterDetails, value) => {
        if (filterDetails.label === 'Size') {

            // Old structure
            const filterValueLabel = document.createElement("label");
            const currentParamValue = Utils.getQueryParam(filterDetails.id);
            if (currentParamValue) {
                const currentParamValueArr = currentParamValue.split(",");
                if (currentParamValueArr.includes(value.label)) {
                    filterValueLabel.classList.add("active");
                }
            }
            filterValueLabel.classList.add("filter-swatch");
            filterValueLabel.setAttribute('role', 'button');
            filterValueLabel.dataset.filterId = filterDetails.id;
            filterValueLabel.dataset.value = value.label;

            filterValueLabel.addEventListener("click", () => {
                const filterParam = Utils.getQueryParam(filterDetails.id);
                let filterParamsArr = [];
                if (filterParam) {
                    filterParamsArr = filterParam.split(",");
                }
                const filterValue = filterValueLabel.dataset.value;
                if (filterParamsArr.includes(filterValue)) {
                    Utils.removeQueryParam(filterDetails.id, filterValue);
                } else {
                    Utils.setQueryParam(filterDetails.id, filterValue);
                }
            });

            const labelText = document.createElement("span");
            labelText.innerText = value.label;
            filterValueLabel.title = value.label;
            filterValueLabel.append(labelText);

            return filterValueLabel;

        } else if(filterDetails?.label){
            // Checkbox structure
            const filterValueLabel = document.createElement("label");
            const checkbox = document.createElement("input");
            checkbox.type = "checkbox";
            checkbox.name = filterDetails.id;
            checkbox.value = filterDetails.id === "filter.p.m.custom.fabric_type" ? (JSON.parse(value.input)?.productMetafield?.value) : value.label;
            if (checkbox && filterDetails) {
                const currentParamValue = Utils.getQueryParam(filterDetails.id);
                if (currentParamValue) {
                    const currentParamValueArr = currentParamValue.split(",");
                    if (currentParamValueArr.includes(value.label)) {
                        filterValueLabel.classList.add("active");
                    }
                }
            }

            const currentParamValue = Utils.getQueryParam(filterDetails.id);
            if (currentParamValue) {
                const currentParamValueArr = currentParamValue.split(",");
                if (currentParamValueArr.includes(value.label)) {
                    checkbox.checked = true;
                }
            }

            filterValueLabel.classList.add("filter-checkbox");
            filterValueLabel.dataset.filterId = filterDetails.id;

            if (filterDetails.id.includes("color")) {
                filterValueLabel.classList.add("filter-color");
                filterValueLabel.style.order = value.label.length;

                const swatchCircle = document.createElement("div");
                swatchCircle.classList.add("swatch-circle");
                swatchCircle.innerHTML = `<span class="hide">${value.label}</span>`;

                const matchedColorSetting = filterColorSettings.find(
                    (color) => color.colorName.toLowerCase() === value.label.toLowerCase()
                );
                const matchedColorImageSetting = filterColorImageSettings.find(
                    (color) => color.colorName.toLowerCase() === value.label.toLowerCase()
                );

                if (matchedColorSetting) {
                    swatchCircle.style.backgroundColor = matchedColorSetting.colorHexValue;
                } else {
                    if (matchedColorImageSetting) {
                        const baseUrl = document.querySelector('[data-file-url-base]').dataset.fileUrlBase;
                        const swatchUrl = baseUrl.replace('multi_small.jpg', matchedColorImageSetting.colorImage).replace('127.0.0.1:9292', 'woxer.com');
                        swatchCircle.style.backgroundImage = `url(${Utils.setImageUrlWidth(swatchUrl, 31)})`;
                    } else {
                        const baseUrl = document.querySelector('[data-file-url-base]').dataset.fileUrlBase;
                        const swatchUrl = baseUrl.replace('multi', value.label.toLowerCase().replaceAll(' ', '-')).replace('127.0.0.1:9292', 'woxer.com');
                        swatchCircle.style.backgroundImage = `url(${Utils.setImageUrlWidth(swatchUrl, 31)})`;
                    }
                }
                filterValueLabel.append(swatchCircle);
            }

            checkbox.addEventListener("change", () => {
                const filterParam = Utils.getQueryParam(filterDetails.id);
                let filterParamsArr = [];
                if (filterParam) {
                    filterParamsArr = filterParam.split(",");
                }    
                const filterValue = checkbox.value;

                if (filterParamsArr.includes(filterValue)) {
                    Utils.removeQueryParam(filterDetails.id, filterValue);
                } else {
                    Utils.setQueryParam(filterDetails.id, filterValue);
                }
            });

            const labelText = document.createElement("span");

            // Temp Fix Rename Some Filters
            if (value.label === "Baller Flex") {
                value.label = "Baller 5\" Flex Boxers";
            } else if (value.label === "Biker Flex") {
                value.label = "Biker 9\" Flex Boxers";
            } else if (value.label === "Baller Fly 5\"") {
                value.label = "Baller 5\" Boxers w/ Fly";
            } else if (value.label === "Baller Fly 7\"") {
                value.label = "Baller 7\" Boxers w/ Fly";
            } else if (value.label === "Biker High Waisted") {
                value.label = "Biker 9\" High Waisted Boxers";
            } else if (value.label === "Boss Flex") {
                value.label = "Boss Flex Sports Bra";
            } else if (value.label === "Icon 2.0") {
                value.label = "Icon Slim Brallete";
            } else if (value.label === "Star High Waisted") {
                value.label = "Star 3” High Waisted";
            }

            labelText.innerText = value.label;

            if (value.label === "Baller 5\" Flex Boxers") {
                value.label = "Baller Flex";
            } else if (value.label === "Biker 9\" Flex Boxers") {
                value.label = "Biker Flex";
            } else if (value.label === "Baller 5\" Boxers w/ Fly") {
                value.label = "Baller Fly 5\"";
            } else if (value.label === "Baller 7\" Boxers w/ Fly") {
                value.label = "Baller Fly 7\"";
            } else if (value.label === "Biker 9\" High Waisted Boxers") {
                value.label = "Biker High Waisted";
            } else if (value.label === "Boss Flex Sports Bra") {
                value.label = "Boss Flex";
            } else if (value.label === "Icon Slim Brallete") {
                value.label = "Icon 2.0";
            } else if (value.label === "Star 3” High Waisted") {
                value.label = "Star High Waisted";
            }

            filterValueLabel.title = value.label;
            filterValueLabel.append(checkbox, labelText);
            filterValueLabel.dataset.value = filterDetails.id === "filter.p.m.custom.fabric_type" ? (JSON.parse(value.input)?.productMetafield?.value) : value.label;

            return filterValueLabel;
        }
    };


    Utils.updateSortingElements = () => {
        const sortByValue = Utils.getQueryParam("sort_by");
        if (sortByValue) {
            document
                .querySelectorAll(".sort-by-list button")
                .forEach((btn) => btn.classList.remove("active"));
            const matchedListElement = document.querySelector(
                `.sort-by-list button[data-value="${sortByValue}"]`
            );
            matchedListElement.classList.add("active");

            // Update mobile sorting elements
            document.querySelectorAll('.sort-by-list-filters button').forEach(mobileBtn => {
                mobileBtn.classList.remove('active');
                const matchedMobileElement = document.querySelector(`.sort-by-list-filters button[data-value="${sortByValue}"]`);
                matchedMobileElement.classList.add('active');
            });
        }
    };

    Utils.resetQueryParams = () => {
        if (document.querySelector('[data-new-collection-structure]')) {
            const url = new URL(window.location.href);
            const params = new URLSearchParams(url.search);

            const spCollection = params.get("sp_collection");
            const newParams = new URLSearchParams();

            if (spCollection) {
                newParams.set("sp_collection", spCollection);
            }

            url.search = newParams.toString();
            window.history.replaceState({}, document.title, url.toString());
        } else {
            const url = new URL(window.location.href);
            const params = new URLSearchParams();
            url.search = params.toString();

            window.history.replaceState({}, document.title, url.toString());
        }
    };

    Utils.getOfferSettings = (productDetails, compareAtPriceValue, priceValue) => {
        let productTags = productDetails.tags || [];
        let offerApplied = false;
        let offerType = null;
        let customOffers = window.offersJson.enabled_offers
        let defaultOffer = window.offersJson.default_offer

        let offerExcludeTags = [];
        let offerDiscount = null;
        let offerDiscountAmount = null;
        let offerPrice = null;
        let dummyPrice = null;
        let offerLabel = null;
        let offerDealLabel = null;
        let displayedPrice = '{price} {subscription_price}';
        let offerLabelColor = null;
        let offerLabelBackground = null;
        let offerTagLine = null;
        let offerTagLineColor = '#CE0000';
        let offerStrokeColor = null;
        let offerBorderRadius = null;
        let defaultOfferApplied = false;
        let offerShowCheckIcon = false;

        if (customOffers.length) {
            customOffers.forEach((customOffer) => {

                if (!window.enable_active_subscriber_offer_found) {
                    Utils.getOffers();
                }

                let excludeOffer = false
                if (customOffer.exclude_tags?.length && customOffer.exclude_tags.filter(excludeTag => productTags.includes(excludeTag)).length) {
                    excludeOffer = true;
                }

                if (
                    !excludeOffer &&
                    !offerApplied &&
                    customOffer.tags?.length && customOffer.tags.filter(customOfferTag => productTags.includes(customOfferTag))?.length
                ) {
                    offerApplied = true;
                    offerDiscount = window.isActiveSubscriber && customOffer.enable_active_subscriber_offer ? customOffer.active_subscriber_discount : customOffer.discount;

                    let isSubscriber = window.customerDetails?.customerTags?.includes('REAL_ACTIVE_SUBSCRIBER');
                    let isClearanceProduct = productDetails?.tags?.includes("CLEARANCE35");
                    if (isClearanceProduct) {
                        offerDiscount = isSubscriber ? 50 : 50;
                    }
                    let isFixedAmountOffer = false;
                    if (customOffer.discount_amount > 0) {
                        isFixedAmountOffer = true;
                        offerDiscountAmount = customOffer.discount_amount;
                    } else {
                        offerDiscountAmount = (priceValue * offerDiscount) / 100;
                    }

                    offerPrice = priceValue - offerDiscountAmount;
                    
                    dummyPrice = priceValue + offerDiscountAmount;
                    displayedPrice = customOffer.priceFormat;
                    offerExcludeTags = customOffer.exclude_tags;
                    offerLabel = window.isActiveSubscriber && customOffer.enable_active_subscriber_offer ? customOffer.active_subscriber_label :customOffer.label;
                    offerDealLabel = customOffer.deal_label;
                    offerLabelColor = customOffer.label_color;
                    offerLabelBackground = customOffer.label_bg_color;
                    offerTagLine = window.isActiveSubscriber && customOffer.enable_active_subscriber_offer ? customOffer.active_subscriber_tag_line :customOffer.tag_line;
                    offerTagLineColor = customOffer.tag_line_color;
                    offerShowCheckIcon = customOffer.show_check_icon;
                    offerStrokeColor = customOffer.label_border_color;
                    offerBorderRadius = customOffer.label_border_radius;
                    offerType = customOffer.offer_type ?? offerType

                    if (isFixedAmountOffer) {
                        offerLabel = offerLabel.replace('{offer_discount_price}', offerDiscountAmount)
                    }
                }
            })
        }

        if (!offerApplied) {

            offerDiscount = Math.round(((compareAtPriceValue - priceValue) * 100.0) / compareAtPriceValue);
            offerPrice = priceValue;
            dummyPrice = priceValue;

            if (offerDiscount > 0 && defaultOffer && Object.keys(defaultOffer).length) {
                offerApplied = true;
                defaultOfferApplied = true;
                offerLabel = `${offerDiscount}% ${defaultOffer.label}`;
                offerTagLine = `${offerDiscount}% ${defaultOffer.tag_line}`;

                if (productTags.includes('WSINGLES')) {
                    offerLabelColor = defaultOffer.singles_label_color
                    offerLabelBackground = defaultOffer.singles_label_bg_color
                } else if (productTags.includes('PACK')) {
                    if (productTags.includes('3PACK')) {
                        offerLabelColor = defaultOffer.pack_3_label_color
                        offerLabelBackground = defaultOffer.pack_3_label_bg_color
                        offerLabel = `${offerDiscount}% ${defaultOffer.label}`;
                        offerTagLine = `${offerDiscount}% ${defaultOffer.tag_line}`;
                    }
                    else if (productTags.includes('4PACK')) {
                        offerLabelColor = defaultOffer.pack_4_label_color
                        offerLabelBackground = defaultOffer.pack_4_label_bg_color
                    }
                    else if (productTags.includes('6PACK')) {
                        offerLabelColor = defaultOffer.pack_6_label_color
                        offerLabelBackground = defaultOffer.pack_6_label_bg_color
                    }
                    else if (productTags.includes('10PACK')) {
                        offerLabelColor = defaultOffer.pack_10_label_color
                        offerLabelBackground = defaultOffer.pack_10_label_bg_color
                    }
                }
            }
        }

        if (!offerApplied) {
            if (productTags.includes('WSINGLES')) {
                let subscriptionOnlyTags = window.globalVariables.settings.subscription_only_tag.split(',');
                let subscriptionOnlyTagFound = false;
                subscriptionOnlyTags.forEach(subscriptionOnlyTag => {
                    if (productTags.includes(subscriptionOnlyTag)) {
                        subscriptionOnlyTagFound = true;
                    }
                })
                displayedPrice = '{price} {subscription_price} <span class="subscriber-text fw-normal">Subscribers</span>'
                if (window.globalVariables.settings.enable_subscription_only && subscriptionOnlyTagFound) {
                    displayedPrice = '{subscription_price} <span class="subscriber-text fw-normal">Subscribers</span>'
                }
            } else {
                displayedPrice = '{price}'
            }
        }

        return {
            offerApplied: offerApplied,
            offerType: offerType,
            offerExcludeTags: offerExcludeTags,
            offerDiscount: offerDiscount,
            offerDiscountAmount: offerDiscountAmount,
            offerPrice: offerPrice,
            dummyPrice: dummyPrice,
            displayedPrice: displayedPrice,
            offerLabel: offerLabel,
            offerDealLabel: offerDealLabel,
            offerLabelColor: offerLabelColor,
            offerLabelBackground: offerLabelBackground,
            offerTagLine: offerTagLine,
            offerTagLineColor: offerTagLineColor,
            offerStrokeColor: offerStrokeColor,
            offerBorderRadius: offerBorderRadius,
            defaultOfferApplied: defaultOfferApplied,
            offerShowCheckIcon: offerShowCheckIcon,
        }
    }

    Utils.updateFilterOptions = () => {
        let processedOption = [];
        document.querySelectorAll("filter-option").forEach((filterOption) => {
            const activeOptions = filterOption.querySelectorAll('.filter-option__values .active')?.length;

            if (!processedOption.includes(filterOption.getAttribute('filter-id'))) {
                let filterLabel = filterOption.getAttribute('filter-details');
                filterLabel = JSON.parse(filterLabel).label;
                filterOption.querySelector('.filter-option__title').innerText = `${filterLabel} ${activeOptions ? `(${activeOptions})` : ``} `
                processedOption.push(filterOption.getAttribute('filter-id'))
            }
        });
    }

    Utils.getOffers = () => {
        window.offersJson = {}
        window.offersJson.enabled_offers = [];
        window.offersJson.default_offer = {};
        window.enable_active_subscriber_offer_found = true;
        window.stylesData = document.querySelector('#global-metaobject-data')?.innerText;

        let offersElement = document.querySelector('#offers-data')
        if (offersElement) {

            window.isActiveSubscriber = offersElement.getAttribute('data-active-subscriber') === 'true' ?? false

            if (!window.isActiveSubscriber && window.customerDetails.customerTags.includes('REAL_ACTIVE_SUBSCRIBER')) {
                window.isActiveSubscriber = true;
            }
            let settings = window.globalVariables.settings;

            for(let i of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20].reverse()) {
                let enabled = settings[`enable_offer_${i}`];
                if (enabled) {
                    window.offersJson.enabled_offers.push({
                        enabled : settings[`enable_offer_${i}`],
                        offer_type : settings[`offer_${i}_type`],
                        offer_discount_type : settings[`offer_${i}_discount_type`],
                        discount : settings[`offer_${i}_discount_percentage`],
                        discount_amount : settings[`offer_${i}_discount_amount`],
                        active_subscriber_discount : settings[`offer_${i}_active_subscriber_discount_percentage`],
                        tags : settings[`offer_${i}_tag`]?.split(','),
                        exclude_tags : settings[`offer_${i}_exclude_tags`]?.split(','),
                        priceFormat: settings[`offer_${i}_price_format`],
                        label : settings[`offer_${i}_tag_name`],
                        deal_label : settings[`offer_${i}_deal_tag_name`],
                        enable_active_subscriber_offer : settings[`enable_active_subscriber_offer_${i}`],
                        active_subscriber_label : settings[`active_subscriber_offer_${i}_tag_name`],
                        label_color : settings[`offer_${i}_tag_color`],
                        label_bg_color : settings[`offer_${i}_tag_bg_color`],
                        label_border_color : settings[`offer_${i}_label_stroke_color`],
                        label_border_radius : settings[`offer_${i}_label_radius`],
                        tag_line : settings[`offer_${i}_tag_line`],
                        active_subscriber_tag_line : settings[`active_subscriber_offer_${i}_tag_line`],
                        tag_line_color : settings[`offer_${i}_tag_line_color`],
                        show_check_icon : settings[`offer_${i}_show_check_icon`],
                        cart_label: settings[`offer_${i}_cart_label`],
                        cart_tag_line: settings[`offer_${i}_cart_tag_line`],
                        cart_success_msg: settings[`offer_${i}_cart_success_msg`],
                    });

                    if (settings[`enable_active_subscriber_offer_${i}`] === undefined) {
                        window.enable_active_subscriber_offer_found = false;
                    }
                }
            }
        }
    }

    Utils.extraInfo = (style) => {
        if (!style) {
            return null;
        }
              if (style.includes('Fly 5')) {
            style = 'ballerfly5'
        } else if (style.includes('Fly 7')) {
            style = 'ballerfly7'
        }

        style = Utils.handleize(style.trim().replaceAll('.', '-')).replace('icon2', 'icon-2-0').replace('boss2', 'boss-2-0').replace('boxer-shorts', 'boxer');

        let stylesData = window.stylesData ? JSON.parse(window.stylesData) : {};

        // Find the record with the given style name
        const record = stylesData[style] || null;

        // If the record is found, return the extra info; otherwise, return null
        return record ? record.description : null;
    };

    Utils.isInViewport = (el, percentVisible) => {
        let rect = el.getBoundingClientRect(),
            windowHeight = window.innerHeight || document.documentElement.clientHeight,
            windowWidth = window.innerWidth || document.documentElement.clientWidth;
    
        const headerHeight = document.querySelector('sticky-header .site-header')?.offsetHeight - 10;
    
        return !(
            Math.floor(100 - (((rect.top - headerHeight) >= 0 ? 0 : (rect.top - headerHeight)) / -rect.height) * 100) <
            percentVisible ||
            Math.floor(100 - ((rect.bottom - headerHeight - windowHeight) / rect.height) * 100) <
            percentVisible ||
            Math.floor(100 - ((rect.left >= 0 ? 0 : rect.left) / -rect.width) * 100) <
            percentVisible ||
            Math.floor(100 - ((rect.right - windowWidth) / rect.width) * 100) <
            percentVisible
        );
    };
    


    Utils.sortProducts = (products) => {
        products.sort((productA, productB) => {
            let productAOrder = 0;
            let productBOrder = 0;
            if (productA.node.productOrder === null) {
                productAOrder = 999;
            }
            if (productB.node.productOrder === null) {
                productBOrder = 999;
            }

            if (
                productA.node.productOrder !== null &&
                productB.node.productOrder !== null
            ) {
                productAOrder = productA.node.productOrder.value;
                productBOrder = productB.node.productOrder.value;
            }
            return productAOrder - productBOrder;
        });
    };

    Utils.renderCardPrice = (
        productDetails,
        priceWrapper,
        compareAtPriceValue,
        priceValue,
        templateContent
    ) => {

        let {
            offerApplied,
            offerType,
            offerExcludeTags,
            offerDiscount,
            offerDiscountAmount,
            offerPrice,
            dummyPrice,
            displayedPrice,
            offerLabel,
            offerDealLabel,
            offerLabelColor,
            offerLabelBackground,
            offerTagLine,
            offerTagLineColor,
            offerStrokeColor,
            offerBorderRadius,
            defaultOfferApplied,
            offerShowCheckIcon,
        } = Utils.getOfferSettings(productDetails, compareAtPriceValue, priceValue);

        let percentageDiscount = '30';

        let isBoxerProduct = productDetails?.tags?.includes("BOXERS_RELEASE");
        if (productDetails?.tags?.includes("ws-boxytee") || productDetails?.tags?.includes("ws_handband")) {
            if (!isActiveSubscriber) {
                isBoxerProduct = true;
            }
        }

        displayedPrice = displayedPrice.replaceAll('{price}',`<span class="regular-price">${Utils.formatMoney(priceValue)}</span>`);
        displayedPrice = displayedPrice.replaceAll('{offer_price}',`<span class="sale-price">${Utils.formatMoney(offerPrice)}</span><span>`);
        displayedPrice = displayedPrice.replaceAll('{offer_discount}', percentageDiscount);
        displayedPrice = displayedPrice.replaceAll('{dummy_price}',`<span class="sale-price">${Utils.formatMoney(dummyPrice)}</span>`);
        displayedPrice = displayedPrice.replaceAll('{strike_price}',`<span class="crossed-price">${Utils.formatMoney(compareAtPriceValue)}</span>`);

        const sellingPlanAllocations = productDetails.variants?.edges[0]?.node?.sellingPlanAllocations || [];
        let sellingPlanPrice = 0;
        let sellingPlan = sellingPlanAllocations.edges[0];
        if (sellingPlan && sellingPlan.node) {
            sellingPlanPrice = sellingPlan.node.priceAdjustments[0].price.amount;
            displayedPrice = displayedPrice.replaceAll('{subscription_price}',`<span class="subscription-price ${isBoxerProduct ? 'd-none': ''}">${Utils.formatMoney(sellingPlanPrice)}`);
        }else{
            displayedPrice = displayedPrice.replaceAll('{subscription_price}',``).replaceAll('Subscribers',``);
        }

        if (displayedPrice.includes('clearance-sale-discount')) {
            displayedPrice = displayedPrice.replaceAll('45%', percentageDiscount + '%')
        }

        priceWrapper.innerHTML = displayedPrice;

        if (offerApplied && offerTagLine) {
            const offerTagLineElement = document.createElement("p");
            offerTagLineElement.classList.add("sale-price", "offer-tag-line", "d-block");
            offerTagLineElement.innerHTML = offerTagLine + (offerShowCheckIcon
                ? ` <div class="bg-danger rounded-circle d-inline-flex tagline-badge">
                    <img src="https://cdn.shopify.com/s/files/1/1412/6778/files/Vector_2.svg?v=1699723893" alt="check" class="w-100">
                </div>`
                : '');
            if (offerTagLineColor) {
                offerTagLineElement.style.color = offerTagLineColor;
            }
            priceWrapper.append(offerTagLineElement);
        }

        let badgePosition = 'bottom';
        if (productDetails.productType && productDetails.productType.includes("pack") && productDetails?.tags?.includes('BF_SALE_PACK_2024')) {
            badgePosition = 'bottom';
        }
        if (productDetails.productType && productDetails.productType.includes("pack") && productDetails?.tags?.includes('HOL3_PACK')) {
            badgePosition = 'bottom';
        }

        if (offerApplied && offerLabel && Shopify.country != 'CA' && Shopify.country != 'GB' && Shopify.country != 'AU' && Shopify.country != 'NZ' && Shopify.country != 'AT') {

            if (
                (
                    priceWrapper.classList.contains('quickbuy-product-price')
                    && offerLabel.length > 0
                )
                ||
                offerDealLabel.length > 0
            ) {
                let offerBadgeElement = document.createElement("span");
                offerBadgeElement.classList.add('badge', 'offer-badge', badgePosition)
                offerBadgeElement.innerHTML = priceWrapper.classList.contains('quickbuy-product-price') ? offerLabel : offerDealLabel
                offerBadgeElement.style.color = offerLabelColor
                offerBadgeElement.style.backgroundColor = offerLabelBackground;
                offerBadgeElement.style.borderRadius = `${offerBorderRadius}px`;
                offerBadgeElement.style.borderColor = offerStrokeColor;
                priceWrapper.append(offerBadgeElement);

                if (priceWrapper.classList.contains('quickbuy-product-price') && offerLabel.length > 10) {
                    offerBadgeElement.classList.add('d-none')
                }
            }

            if (
                templateContent
                && templateContent.querySelector('[data-plp-sale-tag]')
                && offerLabel.length > 0
            ) {
                templateContent.querySelector('[data-plp-sale-tag]').innerHTML = offerLabel;
                templateContent.querySelector('[data-plp-sale-tag]')?.classList?.remove('d-none');
                if (productDetails?.tags?.includes('CLEARANCE35')) {
                    templateContent.querySelector('[data-plp-sale-tag]')?.classList?.add('clearance-35');
                }
            }
        }
    };

    Utils.isMobile = () => {
        const width = window.innerWidth;

        return width <= 769;
    };

    Utils.renderQuickBuy = (productCard) => {
        const quickBuy = document.createElement("quick-buy");
        quickBuy.setAttribute('product-type', productCard.getAttribute("product-type"))
        const productCardMediaWrapper = productCard.querySelector(
            ".product-card__media"
        );
        productCardMediaWrapper.append(quickBuy);
        window.custom_pd_description = productCard?.querySelector(".product-card__detail")?.innerHTML
    };

    const facetsTitle = document.querySelector('.collection-facets-title > span');
    if (Utils.isMobile()) {
        facetsTitle.innerText = 'Filters';
    }

    const body = document.querySelector('body');
    const html = document.querySelector('html');

    // Collection text section
    const readMoreBtn = document.querySelector(".collection-text-read-more");
    if (readMoreBtn) {
        readMoreBtn.addEventListener("click", () => {
            const sectionWrapper = readMoreBtn.closest(".collection-text");
            const collectionTextWrapper = sectionWrapper.querySelector(
                ".collection-text__wrapper"
            );
            collectionTextWrapper.classList.toggle("collapse");
        });
    }

    // Mobile filter
    const mobileFilterToggle = document.querySelector(".filter-mobile-toggle");
    const filtersWrapper = document.querySelector(".collection-facets-wrapper");
    mobileFilterToggle.addEventListener("click", () => {
        document.querySelectorAll('.collection-facets__filter-options filter-option, .collection-facets__filter-options .sort-by-filters')
            .forEach(ele => ele.classList.add('close'))
        filtersWrapper.classList.add("open");
        html.classList.add("open");
    });

    const mobileFilterCloseBtns = document.querySelectorAll(
        ".facets-mobile-close, .filter-view-products"
    );

    mobileFilterCloseBtns.forEach((closeBtn) => {
        closeBtn.addEventListener("click", () => {
            filtersWrapper.classList.remove("open");
            html.classList.remove("open");
        });
    });

    // Global selectors
    const collectionsElements = Array.from(
        document.querySelectorAll(".collection-bundle")
    );

    const collectionOverlay = document.querySelector(".collection-overlay");
    if (collectionOverlay) {
        collectionOverlay.addEventListener('click', () => {
            document.querySelectorAll('quick-buy').forEach(elementToRemove => elementToRemove.remove());
            document.querySelector('.collection-facets-wrapper').classList.remove('open');
            html.classList.remove('open');
        });
    }

    const filterColorSettings = JSON.parse(
        document.getElementById("filter-color-settings").innerText
    );

    const filterColorImageSettings = JSON.parse(
        document.getElementById("filter-color-image-settings").innerText
    );

    const filterSortingSettings = JSON.parse(
        document.getElementById("filter-sorting-settings").innerText
    );

    const subFilterSortingSettings = JSON.parse(
        document.getElementById("sub-filter-sorting-settings").innerText
    );

    const paramChangeEvent = new CustomEvent("paramchange", {
        detail: {
            message: "Parameter Change",
        },
    });

    // Global settings
    const productCardImageWidth = 600;
    let maxPrice = 0;

    window.defaultScrollEffect = false;
    // Event listeners
    if (menuAction === 'scroll') {
        document.querySelectorAll('.collection-menu__item a:not([data-plp-filter-card],[data-plp-new-structure-card])').forEach((el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                const target = e.target.closest('a').getAttribute('href');
                history.pushState(null, null, `${window.location.origin}${window.location.pathname}?scrollto=${target.replaceAll('#','')}`);
                const targetElement = document.querySelector(target);
                window.scroll(0, Number(targetElement.offsetTop) - 180);
            })
        })

        document.querySelectorAll('.collection-menu__item-sticky:not(.redirect) a').forEach((el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                const target = e.target.getAttribute('href');
                history.pushState(null, null, `${window.location.origin}${window.location.pathname}?scrollto=${target.replaceAll('#','')}`);
                const targetElement = document.querySelector(target);
                window.defaultScrollEffect = true;
                window.scroll(0, Number(targetElement.offsetTop) - 180);
                setTimeout(() => {
                    window.defaultScrollEffect = false;
                }, 2000);
                document.querySelector('.collection-menu__item-sticky.active')?.classList.remove('active');
                el.closest('.collection-menu__item-sticky')?.classList.add('active')
            })
        })
    }

    document.querySelectorAll('[data-pack-redirect-card]').forEach(ele => {
        ele.addEventListener('click', (event) => {
            if (!event.target.closest('img')) {
                return;
            }
            document.querySelectorAll('.filter-option__values label[data-value="4 Pack"]:not(.disabled):not(.active), ' +
                '.filter-option__values label[data-value="6 Pack"]:not(.disabled):not(.active), ' +
                '.filter-option__values label[data-value="10 Pack"]:not(.disabled):not(.active)')
                .forEach(ele => {
                    ele.click();
                })
            window.scrollTo({
                top: 700,
                behavior: "smooth"
            })
        })
    })

    document.querySelectorAll('[data-plp-filter-card]:not([data-plp-new-structure-card])').forEach(ele => {
        ele.addEventListener('click', (event) => {
            let element = ele.closest('[data-plp-filter-card]')
            let filterValue = element.getAttribute('data-plp-filter-card');
            document.querySelector(`.filter-option__values label[data-value="${filterValue}"]:not(.disabled):not(.active)`)?.click();
            window.scrollTo({
                top: document.querySelector('.collection-product-list')
                    ? (document.querySelector('.collection-product-list')?.offsetTop - 100)
                    : 0
            })
        })
    })

    document.querySelectorAll('[data-plp-new-structure-card]:not(.redirect)').forEach(ele => {
        ele.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();
            let element = event.target.closest('[data-plp-new-structure-card]');
            let newValue = element.getAttribute('data-plp-new-structure-card');

            document.querySelectorAll('[data-plp-new-structure-products]').forEach(ele => ele.classList.add('d-none'));
            document.querySelector(`[data-plp-new-structure-products="${newValue}"]`)?.classList?.remove('d-none');
            const url = new URL(window.location.href);
            url.searchParams.set("sp_collection", newValue);
            history.pushState(null, null, url.toString());

            if (document.querySelector('[data-final-breadcrumb]')) {
                let breadTitle = element?.getAttribute('data-card-title')?.replace('All Underwear', '')?.replace('Shop All Bralettes & Tops', '')?.replace('Shop All Tops', '');
                if (breadTitle) {
                    document.querySelectorAll('[data-final-breadcrumb]').forEach(ele => ele.innerHTML = breadTitle);
                    document.querySelectorAll('.breadcrumb-wrapper .last-divider').forEach(ele => ele?.classList?.remove('d-none'));
                } else {
                    document.querySelectorAll('[data-final-breadcrumb]').forEach(ele => ele.innerHTML = breadTitle);
                    document.querySelectorAll('.breadcrumb-wrapper .last-divider').forEach(ele => ele?.classList?.add('d-none'));
                }
            }

            adjustBredcrumbs();
            renderCollection(getCollectionQuery());
            document.querySelectorAll('.collection-menu__items .collection-menu__item')?.forEach(ele => ele.classList.remove('d-none'));
            event.target.closest('.collection-menu__items .collection-menu__item')?.classList.add('d-none');
        })
    })

    const clearAllButtons = document.querySelectorAll(".filter-clear-all");
    clearAllButtons.forEach((clearALlBtn) => {
        clearALlBtn.addEventListener("click", () => {
            Utils.resetQueryParams();
            document.querySelector('.filter-price').innerHTML = `
            <div>
                <div class="d-flex align-items-center justify-content-between mb-2">
                    <div data-price-lower>
                        
                    </div>
                    <div data-price-higher>
                        
                    </div>
                </div>
                <div id="priceSlider"></div>
            </div>
            `;
            window.dispatchEvent(paramChangeEvent);
            if (window.innerWidth <= 768) {
                filtersWrapper?.classList.remove("open");
                html.classList.remove("open");
            }
        });
    });

    const attachFiltersEvents = (filterOption) => {
        // Collapsible Toggle
        const filterOptionToggle = filterOption.querySelector(
            ".filter-option__toggle"
        );
        const filterOptionValuesWrapper = filterOption.querySelector(
            ".filter-option__values"
        );

        filterOptionToggle.addEventListener("click", () => {
            if (filterOption.closest(".style_filter_option") && document.querySelector('body:has(.jumplink_ab_new)')) {
                filterOption.classList.remove("style_filter_option");
            } else {
                filterOption.classList.toggle("close");
            }
            const filterOptionElement = filterOption.closest('filter-option');
            const filterValues = filterOptionElement.querySelector('.filter-option__values');
            if (Utils.isMobile()) {
                filterValues.scrollIntoView({behavior: 'smooth'});
            }
            let filterContainer = document.querySelector(".collection-facets-wrapper");
            let moreFilterArrow = document.querySelector('.collection-product-list .filter_scroll_down');
            if (moreFilterArrow && !Utils.isMobile()) {
                if (isScrollableVertically(filterContainer)) {
                    moreFilterArrow?.classList?.add('d-none');
                } else {
                    moreFilterArrow?.classList?.add('d-none');
                }

                let isScrollToBottom = false;

                function scrollToBottom() {
                    filterContainer.scrollTop = filterContainer.scrollHeight;
                }
                function scrollToTop() {
                    filterContainer.scrollTop = 0;
                }
                function toggleScroll() {
                    if (isScrollToBottom) {
                        scrollToTop();
                        moreFilterArrow.style.transform = `rotate(0deg)`
                    } else {
                        scrollToBottom();
                        moreFilterArrow.style.transform = `rotate(180deg)`
                    }
                    isScrollToBottom = !isScrollToBottom;
                }

                moreFilterArrow.addEventListener('click', toggleScroll);
            }
        });
    };

    const attachProductCardsEvents = (productCard) => {
        const quickAddTrigger = productCard.querySelector(
            ".product-card__quickadd-btn"
        );
        const productTags = productCard.getAttribute('product-tags');
        const productType = productCard.getAttribute("product-type");
        if (productType === 'mix_pack' || productTags?.toUpperCase()?.split(',')?.includes('QANOSHOW')) {
            quickAddTrigger.classList.add('d-none')
        }

        quickAddTrigger.setAttribute('product-type', productType);

        quickAddTrigger.addEventListener("click", () => {
            Utils.renderQuickBuy(productCard);
        });

        const productMediaAction = productCard.querySelector('.product-card__media-action');
        productMediaAction.addEventListener('click', () => {
            productCard.querySelector('.product-card__url').click();
        });
    };

    const attachProductColorSwatchEvents = (productColorSwatch) => {
        const swatchBtnTrigger = productColorSwatch.querySelector(".product-swatch");
        swatchBtnTrigger.setAttribute("type", "button");

        let siblingProductDetail = JSON.parse(
            productColorSwatch.getAttribute("sibling-product-details")
        );

        if (siblingProductDetail.node.tags.includes('WSINGLES')) {
            swatchBtnTrigger.classList.add('swatch-single');
        }

        swatchBtnTrigger.addEventListener("click", () => {
            const siblingProductDetails = JSON.parse(
                productColorSwatch.getAttribute("sibling-product-details")
            );
            const firstImage = Utils.setImageUrlWidth(
                siblingProductDetails.node.images.edges[0].node.url,
                productCardImageWidth
            );
            const secondImage = Utils.setImageUrlWidth(
                siblingProductDetails.node.images.edges[1].node.url,
                productCardImageWidth
            );
            const productCard = productColorSwatch.closest("product-card");

            // Remove active class
            productCard
                .querySelectorAll(".product-swatch__image")
                .forEach((swatchImage) => swatchImage.classList.remove("active"));
            productColorSwatch
                .querySelector(".product-swatch__image")
                .classList.add("active");

            // Update selected ID
            productCard.setAttribute('data-selected-id', Utils.formatProductId(siblingProductDetails.node.id));

            // Update title

            productCard.querySelector(".product-card__title").innerText =
                siblingProductDetails.node.title;

            // Update images
            productCard
                .querySelector(".product-card__first-image")
                .setAttribute("src", firstImage);

            if (!Utils.isMobile()) {
                productCard
                    .querySelector(".product-card__second-image")
                    .setAttribute("src", secondImage);
            }

            // Update product's URL
            productCard
                .querySelectorAll(".product-card__url, .product-card__swatches-plus")
                .forEach(
                    (productCardLink) =>
                        productCardLink.setAttribute('href', `/products/${siblingProductDetails.node.handle}`)
                );

            // Update price
            Utils.renderCardPrice(
                siblingProductDetails.node,
                productCard.querySelector(".product-card__price"),
                siblingProductDetails.node.compareAtPriceRange.minVariantPrice.amount,
                siblingProductDetails.node.priceRange.minVariantPrice.amount,
                productCard
            );

            // Refresh reviews
            productCard.querySelector(".okendo-star-rating").setAttribute("data-oke-reviews-product-id", "shopify-"+Utils.formatProductId(siblingProductDetails.node.id));

            const quickBuysOpenCount = Array.from(
                document.querySelectorAll("quick-buy")
            ).length;
            if (quickBuysOpenCount > 0) {
                Utils.renderQuickBuy(productCard);
            }

            productColorSwatch
                .closest("product-card")
                .setAttribute(
                    "data-selected-id",
                    Utils.formatProductId(siblingProductDetails.node.id)
                );
        });
    };

    attachQuickBuyEvents = (quickBuy,productTag,productData) => {
        const quickbuyAtcBtn = quickBuy.querySelector(".quickbuy-atc");
        const variants = JSON.parse(quickBuy.getAttribute("variants"));
        
        let selectedVariantId = quickBuy.dataset.selectedVariantId;
        const quickbuySubscriptionCheckbox = document.querySelector(
            ".subscribe_save_price input"
        );

        quickbuyAtcBtn.addEventListener("click", async (event) => {
            event.preventDefault();
            let productId = productData?.data?.product?.id?.split('gid://shopify/Product/')[1];
            if (selectedVariantId) {
                quickbuyAtcBtn.innerText = "Adding";
                const matchedVariant = variants.find(
                    (variant) =>
                        parseInt(Utils.formatVariantId(variant.node.id)) ===
                        parseInt(Utils.formatVariantId(selectedVariantId))
                );
                const sellingPlanAllocations =
                    matchedVariant.node.sellingPlanAllocations.edges;
                const subscriptionEnabled = quickBuy.querySelector(
                    ".subscribe_save_price input"
                ).checked;
                if (sellingPlanAllocations.length > 0 && subscriptionEnabled) {
                    const sellingPlanId = parseInt(
                        Utils.formatSellingPlanId(
                            sellingPlanAllocations[0].node.sellingPlan.id
                        )
                    );
                    await Utils.addVariantToCart(selectedVariantId, sellingPlanId);
                } else {
                    await Utils.addVariantToCart(selectedVariantId);
                }
                quickbuyAtcBtn.innerText = "Added!";

                try {
                    window.VWO = window.VWO || [];
                    VWO.event = VWO.event || function () {VWO.push(["event"].concat([].slice.call(arguments)))};

                    VWO.event("customAddToCart", {
                        cart: 1
                    });

                    if (subscriptionEnabled) {
                        VWO.event("customAddSubscriptionToCart", {
                            cart: 1
                        });
                    }
                    try{
                        let items=[];
                        let obj={};
                        let price = matchedVariant.node.price.amount;
                        if (sellingPlanAllocations.length > 0 && subscriptionEnabled) {
                            price = matchedVariant.node.sellingPlanAllocations.edges[0].node.priceAdjustments[0].price.amount;
                                             ;
                        }
                        obj['productId']=productId;
                        obj['productVariantId']=selectedVariantId;
                        obj['product_name']=productData?.data?.product?.title;
                        obj['product_image']=productData?.data?.product?.featuredImage?.url;
                        obj['price']=[{
                            "value": price,
                            "currency": "USD"
                        }]
                        items.push(obj);
                        Utility._triggerAddToCartView(items);
                    }catch(error){
                        console.error(error);
                    }
                } catch (e) {
                    console.error(e);
                }

                setTimeout(() => {
                    quickBuy.remove();
                }, 500);
            } else {
                const matchedVariant = variants.find(
                    (variant) =>
                        parseInt(Utils.formatVariantId(variant.node.id)) ===
                        parseInt(
                            selectedVariantId || Utils.formatVariantId(variants[0].node.id)
                        )
                );
                let variantPrice = 0;
                if (quickbuySubscriptionCheckbox.checked) {
                    const sellingPlanAllocation =
                        matchedVariant.node.sellingPlanAllocations.edges[0].node;
                    variantPrice = sellingPlanAllocation.priceAdjustments[0].price.amount;
                } else {
                    variantPrice = matchedVariant.node.price.amount;
                }
                quickbuyAtcBtn.classList.add("btn-warning");

                quickbuyAtcBtn.innerText = `Select size`;
                setTimeout(() => {
                    quickbuyAtcBtn.innerText = `Add to bag`;
                    quickbuyAtcBtn.classList.remove("btn-warning");
                }, 1000);
            }
        });

        const sizeGuideBtn = quickBuy.querySelector(".size-guide-trigger");
        sizeGuideBtn.addEventListener("click", (event) => {
            event.preventDefault();
            document.querySelector('#new-size-guide-popup .modal').classList.add('open');
            if (productTag.includes('ws-tanktoprib')) {
                document.querySelector('#new-size-guide-popup .modal [data-style-tab="size-guide-tank-top"]')?.click();
                document.querySelector('#new-size-guide-popup .modal [data-style-tab="size-guide-tank-top"]')?.classList.add('open');
                document.querySelector('#new-size-guide-popup .modal [data-style-tab="size-guide-bralettes"]')?.classList.remove('open');
                document.querySelector('#new-size-guide-popup .modal [data-style-tab="size-guide-underwear"]')?.classList.remove('open');
                document.querySelector('#new-size-guide-popup .modal [data-style-tab="size-guide-boxy-tee"]')?.classList.remove('open');
            } else if (productTag.includes('UNDERWEAR')) {
                document.querySelector('#new-size-guide-popup .modal [data-style-tab="size-guide-underwear"]')?.click();
                document.querySelector('#new-size-guide-popup .modal [data-style-tab="size-guide-underwear"]')?.classList.add('open');
                document.querySelector('#new-size-guide-popup .modal [data-style-tab="size-guide-bralettes"]')?.classList.remove('open');
                document.querySelector('#new-size-guide-popup .modal [data-style-tab="size-guide-tank-top"]')?.classList.remove('open');
                document.querySelector('#new-size-guide-popup .modal [data-style-tab="size-guide-boxy-tee"]')?.classList.remove('open');
            } else if (productTag.includes('BRALETTES')) {
                document.querySelector('#new-size-guide-popup .modal [data-style-tab="size-guide-bralettes"]')?.click();
                document.querySelector('#new-size-guide-popup .modal [data-style-tab="size-guide-bralettes"]')?.classList.add('open');
                document.querySelector('#new-size-guide-popup .modal [data-style-tab="size-guide-tank-top"]')?.classList.remove('open');
                document.querySelector('#new-size-guide-popup .modal [data-style-tab="size-guide-underwear"]')?.classList.remove('open');
                document.querySelector('#new-size-guide-popup .modal [data-style-tab="size-guide-boxy-tee"]')?.classList.remove('open');
            } else if (productTag.includes('ws-boxytee')) {
                document.querySelector('#new-size-guide-popup .modal [data-style-tab="size-guide-boxy-tee"]')?.click();
                document.querySelector('#new-size-guide-popup .modal [data-style-tab="size-guide-boxy-tee"]')?.classList.add('open');
                document.querySelector('#new-size-guide-popup .modal [data-style-tab="size-guide-bralettes"]')?.classList.remove('open');
                document.querySelector('#new-size-guide-popup .modal [data-style-tab="size-guide-tank-top"]')?.classList.remove('open');
                document.querySelector('#new-size-guide-popup .modal [data-style-tab="size-guide-underwear"]')?.classList.remove('open');
            }
        });

        // Option swatches
        const quickBuyOptions = quickBuy.querySelectorAll(
            ".quickbuy-options.size button"
        );

        quickBuyOptions.forEach((optionBtn) => {
            optionBtn.addEventListener("click", () => {
                quickBuyOptions.forEach((btn) => btn.classList.remove("active"));
                quickBuy.dataset.selectedVariantId = Utils.formatVariantId(
                    optionBtn.dataset.variantId
                );
                optionBtn.classList.add("active");

                selectedVariantId = quickBuy.dataset.selectedVariantId;

                // Change ATC button label
                const matchedVariant = variants.find(
                    (variant) =>
                        parseInt(Utils.formatVariantId(variant.node.id)) ===
                        parseInt(
                            selectedVariantId || Utils.formatVariantId(variants[0].node.id)
                        )
                );
                let variantPrice = 0;
                if (quickbuySubscriptionCheckbox.checked) {
                    const sellingPlanAllocation =
                        matchedVariant.node.sellingPlanAllocations.edges[0].node;
                    variantPrice = sellingPlanAllocation.priceAdjustments[0].price.amount;
                } else {
                    variantPrice = matchedVariant.node.price.amount;
                }
                quickbuyAtcBtn.innerText = `Add to bag`;
            });
        });

        document
            .querySelector(".subscribe_save_price input")
            .addEventListener("change", function () {
                const matchedVariant = variants.find(
                    (variant) =>
                        parseInt(Utils.formatVariantId(variant.node.id)) ===
                        parseInt(
                            selectedVariantId || Utils.formatVariantId(variants[0].node.id)
                        )
                );
                if (this.checked) {
                    const sellingPlanAllocation =
                        matchedVariant.node.sellingPlanAllocations.edges[0].node;
                    const sellingPlanPrice =
                        sellingPlanAllocation.priceAdjustments[0].price.amount;
                        quickbuyAtcBtn.innerText = `Add to bag`;
                } else {
                    quickbuyAtcBtn.innerText = `Add to bag`;
                }
            });

        const quickBuyCloseBtn = quickBuy.querySelector(".quickbuy-close");
        quickBuyCloseBtn.addEventListener("click", () => {
            quickBuy.remove();
            html.classList.remove("open");
        });

        // Close quickbuy on mouseleave
        if (!Utils.isMobile()) {
            quickBuy.addEventListener('mouseleave', () => {
                quickBuy.remove();
            });
        }
    };

    // Sort by events
    const sortBySelector = document.querySelector(
        ".collections-bundles__sort-by-selector"
    );
    sortBySelector.addEventListener("change", function () {
        Utils.setQueryParam("sort_by", this.value);
        Utils.updateSortingElements();
    });

    const sortByListBtns = document.querySelectorAll(".sort-by-list button");
    sortByListBtns.forEach((btn) => {
        btn.addEventListener("click", () => {
            const sortingValue = btn.dataset.value;
            const masterSelector = document.querySelector(
                ".collections-bundles__sort-by-selector"
            );
            masterSelector.value = sortingValue;
            const changeEvent = new Event("change");
            masterSelector.dispatchEvent(changeEvent);
            document.querySelector(".sort-by-list").classList.toggle("hide");
            document
                .querySelector(".collections-bundles__sort-by-trigger")
                .classList.toggle("open");
        });
    });

    const sortListTrigger = document.querySelector(
        ".collections-bundles__sort-by-trigger"
    );
    sortListTrigger.addEventListener("click", () => {
        sortListTrigger.classList.toggle("open");
        document.querySelector(".sort-by-list").classList.toggle("hide");
    });

    document.addEventListener("click", function (event) {
        const elem = document.querySelector(".sort-by-wrapper");
        const outsideClick = !elem.contains(event.target);
        if (outsideClick) {
            document.querySelector(".sort-by-list").classList.add("hide");
            document.querySelector('.collections-bundles__sort-by-trigger').classList.remove('open');
        }
    });

    // Sort by filters mobile
    document.querySelectorAll('.sort-by-list-filters button').forEach(btn => {
        btn.addEventListener('click', () => {
            // Reset buttons
            document.querySelectorAll('.sort-by-list-filters button').forEach(sortBtn => sortBtn.classList.remove('active'));
            const sortingValue = btn.dataset.value;
            sortBySelector.value = sortingValue;
            const changeEvent = new Event("change");
            sortBySelector.dispatchEvent(changeEvent);
            btn.classList.add('active');
        });
    });

    document.querySelector('.sort-by-filters__trigger').addEventListener('click', function() {
        const sortByWrapper = this.closest('.sort-by-filters');
        sortByWrapper.classList.toggle('close');
    });

    // Web Components

    class QuickBuy extends HTMLElement {
        constructor() {
            super();
        }

        async connectedCallback() {

            let settings = window.globalVariables.settings;

            let enableNewRelease = settings.enable_new_release;
            let newReleaseSinglesProductTag = settings.new_release_singles_product_tag;
            let newReleasePacksProductTag = settings.new_release_packs_product_tag;

            const quickBuyElement = this;
            const template = document.getElementById("quickbuy-template");
            const templateinstance = template.cloneNode(true);
            const templateContent = templateinstance.content;

            const productCard = this.closest('product-card');
            const productId = productCard?.dataset.selectedId;
            const productDetails = JSON.parse(productCard?.getAttribute("product-details"));
            const collectionData = JSON.parse(productCard?.getAttribute("collection-data"));
            const productTags = productDetails.tags;

            
            const productQuery = SINGLE_PRODUCT_QUERY.replaceAll(
                "{{product_id}}",
                `gid://shopify/Product/${productId}`
            );
            
            let productData={};
            if (productsData[productId]) {
                productData = productsData[productId];
            }else{
                productData = await useQuery(productQuery);
                productsData[productId]=productData;
            }
            const productVariants = productData.data.product.variants.edges;

            const sizeValues = productVariants.map((variant) => {
                const sizeOption = variant.node.selectedOptions.find((option) =>
                    option.name.includes("Size")
                );
                return {
                    variantId: Utils.formatVariantId(variant.node.id),
                    value: sizeOption.value,
                    availableForSale: variant.node.availableForSale
                };
            });

            // Close other quickbuys
            document.querySelectorAll("quick-buy").forEach(function(quickBuyInstance) {
                if (quickBuyInstance.isEqualNode(quickBuyElement) === false) {
                    quickBuyInstance.remove();
                }
            });

            html.classList.add("open");
            let extra_details = Utils.extraInfo(productData.data.product.productType ?? null) || window.custom_pd_description

            const quickBuyImage = templateContent.querySelector('.quickbuy-product-image');
            quickBuyImage.setAttribute('src', Utils.setImageUrlWidth(productData.data.product.featuredImage.url, 200));
            quickBuyImage.setAttribute('alt', productData.data.product.featuredImage.altText);
            templateContent.querySelector('.quickbuy-product-title').innerText = productData.data.product.title;
            if (extra_details && templateContent.querySelector('.quickbuy-product-extra-description')) {
                templateContent.querySelector('.quickbuy-product-extra-description').innerHTML = extra_details;
                templateContent.querySelector('.quickbuy-product-extra-description')?.classList?.remove('d-none')
            } else {
                templateContent.querySelector('.quickbuy-product-extra-description')?.classList?.add('d-none')
            }

            templateContent.querySelector(
                ".quickbuy-atc"
            ).innerText = `Add to Bag`;

            if (
                window.globalVariables.settings.preorder_message_tag_1.length
                && productTags.includes(window.globalVariables.settings.preorder_message_tag_1)
            ) {
                templateContent.querySelector('.only-subscription-note.tag_' + window.globalVariables.settings.preorder_message_tag_1)?.classList.remove('d-none');
            }

            if (
                window.globalVariables.settings.preorder_message_tag_2.length
                && productTags.includes(window.globalVariables.settings.preorder_message_tag_2)
            ) {
                templateContent.querySelector('.only-subscription-note.tag_' + window.globalVariables.settings.preorder_message_tag_2)?.classList.remove('d-none');
            }
            
            sizeValues.forEach((size) => {
                let sizeAvailableForSale = size.availableForSale;
                if (sizeAvailableForSale) {
                    if (productTags.includes(`OOS_${size.value}`)) {
                        sizeAvailableForSale = false
                    }
                }
                const sizesWrapper = templateContent.querySelector(".quickbuy-options.size");
                const sizeItem = document.createElement("li");
                sizeItem.innerHTML = `
                    <button ${!sizeAvailableForSale ? 'class="unavailable"' : ''} data-link-category="QUICK_ADD" data-link-subcategory="${collectionData.collection?.handle?.replace("col1-", "").replaceAll("-", " ").toUpperCase()}" data-link-text="${size.value}" data-variant-id="${size.variantId}" data-option-name="${size.value}" type="button">${size.value}
                        <img
                          class="crossed-out"
                          src="https://cdn.shopify.com/s/files/1/1412/6778/files/soldout.webp"
                          alt="Product sold out"
                        >
                    </button>`;
                sizesWrapper.append(sizeItem);
            });

            const firstVariantPlanAllocations =
                productData.data.product.variants.edges[0].node.sellingPlanAllocations
                    .edges;

            let subscriptionOnlyTags = window.globalVariables.settings.subscription_only_tag.split(',');
            let subscriptionOnlyTagFound = false;
            subscriptionOnlyTags.forEach(subscriptionOnlyTag => {
                if (productTags.includes(subscriptionOnlyTag)) {
                    subscriptionOnlyTagFound = true;
                }
            })

            if (templateContent.querySelector(".subscribe_save_price input") && window.globalVariables.settings.enable_subscription_only && subscriptionOnlyTagFound) {
                templateContent.querySelector(".subscribe_save_price input").click();
            }
                    
            if (firstVariantPlanAllocations.length === 0 || productTags.includes('RIBSINGLES') || (window.globalVariables.settings.enable_subscription_only && subscriptionOnlyTagFound)) {
                templateContent.querySelector(".subscribe_save_price").style.display =
                    "none";
            } else {
                const planAllocation = firstVariantPlanAllocations[0].node;
                const planCompareAtPrice =
                    planAllocation.priceAdjustments[0].compareAtPrice.amount;
                const planPrice = planAllocation.priceAdjustments[0].price.amount;

                templateContent.querySelector(
                    "[data-subscription-price]"
                ).innerHTML = `<span class="subscription-amount">${Utils.formatMoney(
                    planPrice
                )}</span> Subscribers`;
                templateContent.querySelector(
                    "[data-subscription-percentage]"
                ).innerText = `${Utils.getOffPercetange(
                    planCompareAtPrice,
                    planPrice
                )}% OFF`;
            }

            templateContent.querySelector(
                ".subscribe_save_price input"
            ).id = `switch-${productId}`;
            templateContent
                .querySelector(".subscribe_save_price label")
                .setAttribute("for", `switch-${productId}`);

            this.setAttribute("variants", JSON.stringify(productVariants));
            this.setAttribute("product-handle", productData.data.product.handle);

            // Build quickbuy color swatches
            const productType = productCard.getAttribute("product-type");
            let swatchCollectionHandle = productType === 'mix_pack'
                ? 'mixpack'
                : Utils.handleize(productType)
                    .replace('baller-high-waisted', 'baller-highwaisted')
                    .replace('biker-high-waisted', 'biker-highwaisted')
                    .replace('baller-padliner', 'baller-pad-liner')
                    .replace('starhighwaisted-pack', 'star-high-waisted-pack')
                    .replace('ballerhighwaisted-pack', 'baller-high-waisted-pack')
                    .replace('bikerhighwaisted-pack', 'biker-high-waisted-pack')
                    .replace('tanktoprib-pack', 'tank-top-rib-pack')
                    .replace('ballerrib-pack', 'baller-rib-pack')
                    .replace('ballerflex-pack', 'baller-flex-pack')
                    .replace('bikerflex-pack', 'biker-flex-pack')
                    .replace('bossflex-pack', 'boss-flex-pack')
                    .replace('starflex-pack', 'star-flex-pack')
                    .replace('braletteluxe_pack', 'bralette-luxe-pack')
                    .replace('ballerluxe_pack', 'baller-luxe-pack')
                    .replace('ballerluxe-pack', 'baller-luxe-pack')
                    .replace('boldluxe_pack', 'bold-luxe-pack')
                    .replace('ballerpadliner-pack', 'baller-pad-liner-pack');

            let siblingProducts = [];
            if (productCard?.dataset?.siblingProductsDetails) {
                siblingProducts = JSON.parse(productCard.dataset.siblingProductsDetails);
            }

            /* -------------- filter pack products ---------------- */
            let productPackSize = productCard.getAttribute('product-pack-size');
            productPackSize = productPackSize.length !== 0 ? productPackSize : false

            siblingProducts = siblingProducts.filter(siblingProduct => {
                return productPackSize && siblingProduct.node.tags.includes('PACK')
                    ? siblingProduct.node.tags.includes(productPackSize + 'PACK')
                    : siblingProduct
            })
            siblingProducts = siblingProducts.filter(siblingProduct => {
                return swatchCollectionHandle.includes('pack') === false
                    ? siblingProduct.node.tags.includes('WSINGLES')
                    : siblingProduct
            })
            if (enableNewRelease && productPackSize && newReleasePacksProductTag) {
                siblingProducts = siblingProducts.filter(siblingProduct => {
                    return productTags.includes(newReleasePacksProductTag)
                        ? siblingProduct.node.tags.includes(newReleasePacksProductTag)
                        : !siblingProduct.node.tags.includes(newReleasePacksProductTag)
                })
            }

            Utils.sortProducts(siblingProducts);

            // Sort the array
            let quickBuyProductID = productCard.getAttribute('product-id')
            siblingProducts.sort((a, b) => {
                if (a.node.id === quickBuyProductID) return -1; // "a" comes first
                if (b.node.id === quickBuyProductID) return 1; // "b" comes first
                return 0; // No change in order
            });

            let filteredProducts = siblingProducts.filter(function(product) {
                return product?.node?.tags?.includes(window.globalVariables.hidden_tag) == false;
            });

            if (window.globalVariables.woxer_only === 'true') {
                filteredProducts = siblingProducts.filter(function(product) {
                    return product?.node?.tags?.includes(window.globalVariables.woxer_only_product_tag) == false;
                });
            }

            siblingProducts=filteredProducts;
            
            let slicedSiblingProducts;
            if (Utils.isMobile()) {
                slicedSiblingProducts = siblingProducts.slice(0, 19);
            } else {
                slicedSiblingProducts = siblingProducts.slice(0, 5);
            }

            const colorSwatchesWrapper = templateContent.querySelector(
                ".quickbuy-options.color"
            );
            slicedSiblingProducts.forEach((siblingProduct) => {
                const colorSwatch = document.createElement(
                    "product-color-swatch"
                );
                colorSwatch.setAttribute(
                    "sibling-product-details",
                    JSON.stringify(siblingProduct)
                );

                let swatchImage = '';
                if (siblingProduct.node.packIcon) {
                    swatchImage = siblingProduct.node.packIcon.reference.image.url;
                }
                else if (siblingProduct.node.featuredImage) {
                    swatchImage = siblingProduct.node.featuredImage.url;
                }

                colorSwatch.setAttribute('swatch-image', swatchImage);

                let swatchImage2 = '';
                if (siblingProduct.node.packIcon) {
                    swatchImage2 = siblingProduct.node.packIcon.reference.image.url;
                }
                else if (siblingProduct.node.featuredImage) {
                    swatchImage2 = siblingProduct.node.featuredImage.url;
                }

                colorSwatch.setAttribute('swatch-image-2', swatchImage2);

                const siblingProductId = Utils.formatProductId(siblingProduct.node.id);
                if (siblingProductId == productId) {
                    colorSwatch.classList.add('active');
                    const colorOptionObj = siblingProduct.node.options.find(option => option.name === 'Color');
                    templateContent.querySelector('[data-current-color]').innerText = colorOptionObj.values[0];
                } else {
                    colorSwatch.classList.remove('active');
                }
                colorSwatch.setAttribute("sibling-product-id", siblingProductId);
                colorSwatchesWrapper.append(colorSwatch);
            });

            let quickBuyPlusProductSwatch = document.createElement('a')
            const productPlusSwatch = productCard.querySelector('.product-card__swatches-plus');
            if (productPlusSwatch) {
                let plusCount = parseInt(productPlusSwatch.getAttribute('quick_add_swatches') || 0);
                plusCount = plusCount > 0 ? `+${plusCount}` : '';
                quickBuyPlusProductSwatch.setAttribute('href', productPlusSwatch.getAttribute('href'))
                quickBuyPlusProductSwatch.classList.add('product-card__swatches-plus')
                quickBuyPlusProductSwatch.innerText = plusCount;
                colorSwatchesWrapper.append(quickBuyPlusProductSwatch)
            }

            // render quickbuy top price
            const selectedSizeSwatch = document.querySelector('.quickbuy-options li button.active');
            let compareAtPrice = 0;
            let price = 0;
            if (selectedSizeSwatch) {
                const selectedVariantId = parseInt(selectedSizeSwatch.dataset.variantId);
                const matchedVariant = productData.data.product.variants.edges.find(variant => variant.id.includes(selectedVariantId));
                compareAtPrice = matchedVariant.compareAtPrice.amount;
                price = matchedVariant.price.amount;
            } else {
                const matchedVariant = productData.data.product.variants.edges[0];
                price = matchedVariant.node.price.amount;
                compareAtPrice = matchedVariant.node.compareAtPrice.amount;
            }
            const priceWrapper = templateContent.querySelector('.quickbuy-product-price');
            if (window.enable_active_subscriber_offer_found) {
                Utils.getOffers();
            }
            Utils.renderCardPrice(productDetails, priceWrapper, compareAtPrice, price, templateContent);

            this.appendChild(templateContent);
            attachQuickBuyEvents(this,productTags,productData);
        }
    }

    class ProductColorSwatch extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            const template = document.getElementById("product-color-swatch-template");
            const templateinstance = template;
            const templateContent = templateinstance.content.cloneNode(true);
            const swatchProductDetails = JSON.parse(
                this.getAttribute("sibling-product-details")
            );
            const swatchImageElement = templateContent.querySelector(
                ".product-swatch__image"
            );

            const swatchImageElement2 = templateContent.querySelector(
                ".product-swatch__image2"
            );
            const swatchImageTitle = swatchProductDetails.node.title;
            const swatchImageTag = swatchProductDetails.node.tags;

            swatchImageElement.innerHTML = `<span class="hide-display">${swatchImageTitle}</span>`;
            swatchImageElement2.innerHTML = `<span class="hide-display">${swatchImageTitle}</span>`;

            if (swatchImageTag?.includes('WSINGLES')) {
                swatchImageElement.style.backgroundImage = `url("${Utils.setImageUrlWidth(this.getAttribute('swatch-image'), 60)}")`;
                swatchImageElement2.style.backgroundImage = `url("${Utils.setImageUrlWidth(this.getAttribute('swatch-image-2'), 60)}")`;
            } else {
                swatchImageElement.style.backgroundImage = `url("${Utils.setImageUrlWidth(this.getAttribute('swatch-image'), 60)}")`;
                swatchImageElement2.style.backgroundImage = `url("${Utils.setImageUrlWidth(this.getAttribute('swatch-image-2'), 60)}")`;
                swatchImageElement.classList.add('pack_pd_swatch')
                swatchImageElement2.classList.add('pack_pd_swatch')
            }
            swatchImageElement.setAttribute("title", swatchImageTitle);
            swatchImageElement?.setAttribute("data-link-text", swatchImageTitle);
            swatchImageElement2.setAttribute("title", swatchImageTitle);

            const productCardId = this.getAttribute("product-card-id");
            const isCurrentCardProduct =
                productCardId === swatchProductDetails.node.id;

            if (isCurrentCardProduct) {
                swatchImageElement.classList.add("active");
                swatchImageElement2.classList.add("active");
            }

            this.appendChild(templateContent);

            attachProductColorSwatchEvents(this);
        }
    }

    class ProductCard extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            const template = document.getElementById("product-card-template");
            const templateinstance = template;
            const templateContent = templateinstance.content.cloneNode(true);
            const collectionData = JSON.parse(this.getAttribute("collection-data"));
            const productDetails = JSON.parse(this.getAttribute("product-details"));
            this.dataset.selectedId = Utils.formatProductId(productDetails.id);
            const title = productDetails.title;

            const extra_info = Utils.extraInfo(productDetails.collectionStyleGroup?.value ?? null);

            const firstImage = {
                src: Utils.setImageUrlWidth(
                    this.getAttribute("first-image-src"),
                    productCardImageWidth
                ),
                alt: Utils.setImageUrlWidth(
                    this.getAttribute("first-image-alt"),
                    productCardImageWidth
                ),
            };
            const secondImage = {
                src: Utils.setImageUrlWidth(
                    this.getAttribute("second-image-src"),
                    productCardImageWidth
                ),
                alt: Utils.setImageUrlWidth(
                    (this.getAttribute("second-image-alt"), productCardImageWidth)
                ),
            };
            templateContent.querySelector(".product-card__title").innerText = title;
            templateContent.querySelector(".product-card__detail").innerHTML = extra_info;

            const priceWrapper = templateContent.querySelector(
                ".product-card__price"
            );
            const compareAtPriceValue = parseFloat(
                productDetails.compareAtPriceRange.minVariantPrice.amount
            );
            const priceValue = parseFloat(
                productDetails.priceRange.minVariantPrice.amount
            );

            Utils.renderCardPrice(
                productDetails,
                priceWrapper,
                compareAtPriceValue,
                priceValue,
                templateContent
            );

            const productId = this.getAttribute("product-id");

            const productURL = this.getAttribute("product-url");
            const anchorElements =
                templateContent.querySelectorAll(".product-card__url");
            anchorElements.forEach((anchor) =>
                anchor.setAttribute("href", productURL)
            );

            const badgePackElement = templateContent.querySelector('.badge-pack');
            if (badgePackElement && productDetails.packThumbnailTagNumber) {
              badgePackElement.classList.remove('d-none');
              badgePackElement.innerText = productDetails.packThumbnailTagNumber.value + ' Pack'
            }

            const firstImageElement = templateContent.querySelector(
                ".product-card__first-image"
            );
            firstImageElement.setAttribute("src", firstImage.src);
            firstImageElement.setAttribute("alt", firstImage.alt);
            firstImageElement?.setAttribute(
                "data-link-subcategory",
                collectionData.collection.handle.replace("col1-", "").replaceAll("-", " ").toUpperCase()
            );
            firstImageElement?.setAttribute("data-link-text", title);

            const productCardMediaAction = templateContent.querySelector(
                ".product-card__media-action"
            );
            let productCardDataLinkSubCategory = collectionData.collection?.handle?.replace("col1-", "").replaceAll("-", " ").toUpperCase();
            productCardMediaAction?.setAttribute(
                "data-link-subcategory",
                productCardDataLinkSubCategory
            );
            productCardMediaAction?.setAttribute("data-link-text", title);

            templateContent.querySelector(".product-card__title")?.setAttribute(
                "data-link-subcategory",
                productCardDataLinkSubCategory
            );
            templateContent.querySelector(".product-card__title")?.setAttribute("data-link-text", title);

            templateContent.querySelector(".product-card__detail")?.setAttribute(
                "data-link-subcategory",
                productCardDataLinkSubCategory
            );
            templateContent.querySelector(".product-card__detail")?.setAttribute("data-link-text", title);

            templateContent.querySelector(".collection_quick_buy_icon svg")?.setAttribute("data-link-subcategory", productCardDataLinkSubCategory);
            templateContent.querySelector(".collection_quick_buy_icon svg")?.setAttribute("data-link-text", title);

            const secondImageElement = templateContent.querySelector(
                ".product-card__second-image"
            );
            // lazy load second image
            secondImageElement.setAttribute("src", secondImage.src);
            secondImageElement.setAttribute("alt", secondImage.alt);

            const okendoReviews = templateContent.querySelector(".okendo-star-rating");
            okendoReviews.setAttribute("data-oke-reviews-product-id", "shopify-"+Utils.formatProductId(productId));

            this.appendChild(templateContent);

            // Attach Product card's events
            attachProductCardsEvents(this);
        }
    }

    class FilterOption extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            const template = document.getElementById("filter-option-template");
            const templateinstance = template.cloneNode(true);
            const templateContent = templateinstance.content;

            // if (Utils.isMobile()) {
                this.classList.add('close');
            // }

            const filterDetails = JSON.parse(this.getAttribute("filter-details"));
            let filterTitle = "";

            if (filterDetails.label === "Filter Color") {
                filterTitle = "Color";
            } else {
                filterTitle = filterDetails.label;
            }
            templateContent.querySelector(".filter-option__title").innerText =
                filterTitle;
            this.setAttribute('filter-label-value', filterTitle.toLowerCase())
            filterDetails.values.forEach((value) => {
                const filterValuesWrapper = templateContent.querySelector(
                    ".filter-option__values"
                );

                if (filterDetails.id.includes("color")) {
                    filterValuesWrapper.classList.add("filter-color-wrapper");
                } else {
                    filterValuesWrapper.classList.add(filterDetails.id.includes("size") ? "grid-filter" : "list-filter");
                }

                if (filterDetails.type === "LIST") {
                    const filterValueLabel = Utils.getListFilterSwatch(
                        filterDetails,
                        value
                    );

                    filterValuesWrapper.append(filterValueLabel);
                } else if (filterDetails.type === "PRICE_RANGE") {
                    filterValuesWrapper.classList.add("filter-price");
                    const priceSlider = `
                    <div>
                        <div class="d-flex align-items-center justify-content-between mb-2">
                            <div data-price-lower>
                                
                            </div>
                            <div data-price-higher>
                                
                            </div>
                        </div>
                        <div id="priceSlider"></div>
                    </div>
                    `;
                    filterValuesWrapper.insertAdjacentHTML('beforeend', priceSlider);
                }
            });

            this.appendChild(templateContent);

            attachFiltersEvents(this, filterDetails);
        }
    }

    class FilterBubble extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            const template = document.getElementById("filter-bubble-filter");
            const templateinstance = template.cloneNode(true);
            const templateContent = templateinstance.content;

            const bubbleParam = this.getAttribute("data-param-name");
            const bubbleValue = this.getAttribute("data-label");
            templateContent.querySelector(".filter-bubble-label").innerText =
                bubbleValue;

            this.appendChild(templateContent);

            this.addEventListener("click", () => {
                if (bubbleParam === 'filter.v.price') {
                    Utils.resetQueryParam('filter.v.price.max');
                    Utils.resetQueryParam('filter.v.price.min');
                    window.dispatchEvent(paramChangeEvent);
                } else {
                    Utils.removeQueryParam(bubbleParam, bubbleValue);
                }
            });
        }
    }

    // Define web components
    customElements.define("product-card", ProductCard);
    customElements.define("filter-option", FilterOption);
    customElements.define("product-color-swatch", ProductColorSwatch);
    customElements.define("quick-buy", QuickBuy);
    customElements.define("filter-bubble", FilterBubble);

    // GraphQL Queries

    const ALL_PRODUCTS_COLLECTION_QUERY = `query BundleCollections {
    collection(handle: "{{collection_handle}}") {
      handle
      products(first: 240 sortKey: {{sort_key}}) {
        edges {
          node {
            id
            title
            handle
            tags
            productType
            priceRange {
              minVariantPrice {
                amount
                currencyCode
              }
              maxVariantPrice {
                amount
                currencyCode
              }
            }
            options {
              name
              values
            }
            variants(first: 1) {
              edges {
                node {
                  sellingPlanAllocations(first: 10) {
                    edges {
                      node {
                        priceAdjustments {
                          price {
                            amount
                            currencyCode
                          }
                          compareAtPrice {
                            amount
                            currencyCode
                          }
                        }
                        sellingPlan {
                          id
                        }
                      }
                    }
                  }
                }
              }
            }
            productOrder: metafield(namespace: "custom", key: "product_order") {
              value
            }
            packThumbnailTagNumber: metafield(namespace: "custom", key: "pack_thumbnail_tag_number") {
              value
            }
            collectionStyleGroup: metafield(namespace: "custom", key: "collection_style_group") {
              value
            }
            compareAtPriceRange {
              minVariantPrice {
                amount
                currencyCode
              }
            }
            images(first: 2) {
              edges {
                node {
                  url
                  altText
                }
              }
            }
          }
        }
        filters {
          id
          label
          type
          values {
            count
            id
            label
            input
          }
        }
      }
    }
  }
`;

    const FILTER_PRODUCTS_QUERY = `query BundleCollections {
  collection(handle: "{{collection_handle}}") {
    handle
    products(first: 75 {{filters_details}} sortKey: {{sort_key}}) {
            edges {
        node {
          id
          title
          handle
          tags
          productType
          packThumbnailTagNumber: metafield(namespace: "custom", key: "pack_thumbnail_tag_number") {
            value
          }
          collectionStyleGroup: metafield(namespace: "custom", key: "collection_style_group") {
            value
          }
          priceRange {
            minVariantPrice {
              amount
              currencyCode
            }
            maxVariantPrice {
              amount
              currencyCode
            }
          }
          options {
            name
            values
          }
          variants(first: 1) {
            edges {
              node {
                sellingPlanAllocations(first: 10) {
                  edges {
                    node {
                      priceAdjustments {
                        price {
                          amount
                          currencyCode
                        }
                        compareAtPrice {
                          amount
                          currencyCode
                        }
                      }
                      sellingPlan {
                        id
                      }
                    }
                  }
                }
              }
            }
          }
          productOrder: metafield(namespace: "custom", key: "product_order") {
            value
          }
          compareAtPriceRange {
            minVariantPrice {
              amount
              currencyCode
            }
          }
          images(first: 2) {
            edges {
              node {
                url
                altText
              }
            }
          }
        }
      }
      filters {
        id
        label
        type
        values {
          count
          id
          label
          input
        }
      }
    }
  }
}
`;

    const SINGLE_PRODUCT_QUERY = `query Product {
    product(id:"{{product_id}}") {
      id
      title
      handle
      productType
      featuredImage {
        url
        altText
      }
      variants(first:100) {
        edges {
          node {
            id
            selectedOptions {
              name
              value
            }
            price {
              amount
              currencyCode
            }
            compareAtPrice {
              amount
              currencyCode
            }
            availableForSale
            sellingPlanAllocations(first:1) {
              edges {
                node {
                  priceAdjustments {
                    price {
                      amount
                      currencyCode
                    }
                    compareAtPrice {
                      amount
                      currencyCode
                    }
                  }
                  sellingPlan {
                    id
                  }
                }
              }
            }
          }
        }
      }
    }
  }`;

    const PRODUCT_SWATCHES_QUERY = `
  query ProductSwatch {
    collection(handle: "{{collection_handle}}") {
      handle
      products(first: 110) {
        edges {
          node {
            id
            title
            handle
            tags
            productType
            collectionStyleGroup: metafield(namespace: "custom", key: "collection_style_group") {
                value
            }
            priceRange {
              minVariantPrice {
                amount
              }
              maxVariantPrice {
                amount
              }
            }
            featuredImage {
              url
            }
            options {
              name
              values
            }
            variants(first: 1) {
              edges {
                node {
                  sellingPlanAllocations(first: 10) {
                    edges {
                      node {
                        priceAdjustments {
                          price {
                            amount
                            currencyCode
                          }
                          compareAtPrice {
                            amount
                            currencyCode
                          }
                        }
                        sellingPlan {
                          id
                        }
                      }
                    }
                  }
                }
              }
            }
            productOrder: metafield(namespace: "custom", key: "product_order") {
              value
            }
            packIcon: metafield(namespace: "custom", key: "pack_icon") {
              reference {
                ... on MediaImage {
                  image {
                    url
                  }
                }
              }
            }
            compareAtPriceRange {
              minVariantPrice {
                amount
              }
            }
            images(first: 2) {
              edges {
                node {
                  url
                  altText
                }
              }
            }
          }
        }
      }
    }
  }
  `;
  const PRODUCT_FILTER_SWATCHES_QUERY = `
  query ProductSwatch {
    collection(handle: "{{collection_handle}}") {
      handle
      products(first: 110 {{filters_details}} sortKey: {{sort_key}}) {
        edges {
          node {
            id
            title
            handle
            tags
            productType
            priceRange {
              minVariantPrice {
                amount
              }
              maxVariantPrice {
                amount
              }
            }
            featuredImage {
              url
            }
            options {
              name
              values
            }
            variants(first: 1) {
              edges {
                node {
                  sellingPlanAllocations(first: 10) {
                    edges {
                      node {
                        priceAdjustments {
                          price {
                            amount
                            currencyCode
                          }
                          compareAtPrice {
                            amount
                            currencyCode
                          }
                        }
                        sellingPlan {
                          id
                        }
                      }
                    }
                  }
                }
              }
            }
            productOrder: metafield(namespace: "custom", key: "product_order") {
              value
            }
            packIcon: metafield(namespace: "custom", key: "pack_icon") {
              reference {
                ... on MediaImage {
                  image {
                    url
                  }
                }
              }
            }
            compareAtPriceRange {
              minVariantPrice {
                amount
              }
            }
            images(first: 2) {
              edges {
                node {
                  url
                  altText
                }
              }
            }
          }
        }
      }
    }
  }
  `;

    // Filter and product calls

    const getCollectionsData = async (query) => {
        const collectionsResponse = collectionsElements.map((collection) => {
            let replacedQuery = query.replaceAll(
                "{{collection_handle}}",
                collection.dataset.handle
            );
            return useQuery(replacedQuery);
        });
        const collectionsData = await Promise.all(collectionsResponse);
        return collectionsData;
    };

    const getMergedFilterOptions = (allCollectionsData) => {
        /* Take all filter values for all collections, and merge them into one single filter set */
        const mergedFilters = [];

        allCollectionsData.forEach((collection) => {
            collection.data.collection.products.filters.forEach((filter) => {
                const isInMergedList = mergedFilters.some(
                    (mergedFilter) => mergedFilter.id === filter.id
                );

                if (!isInMergedList) {
                    const newFilter = {
                        id: filter.id,
                        label: filter.label,
                        type: filter.type,
                        values: filter.values,
                    };
                    mergedFilters.push(newFilter);
                }

                filter.values.forEach((value) => {
                    const matchedFilterIndex = mergedFilters.findIndex(
                        (mergedFilter) => mergedFilter.id === filter.id
                    );
                    const isValueInList = mergedFilters[matchedFilterIndex].values.some(
                        (matchedValue) => matchedValue.id === value.id
                    );
                    if (!isValueInList) {
                        mergedFilters[matchedFilterIndex].values.push(value);
                    }
                });
            });
        });
        return mergedFilters;
    };

    // Web components rendering functions
    const removeAllElements = (renderFilterOptions) => {
        const productCards = document.querySelectorAll("product-card");
        const filterOptions = document.querySelectorAll("filter-option");

        productCards.forEach((productCard) => productCard.remove());
        if (renderFilterOptions) {
            filterOptions.forEach((filterOption) => filterOption.remove());
        }
    };

    const createFilterOptions = (filters) => {
        filters.forEach((filter) => {
            let hideFilters = document.querySelector('[data-hide-filters]').getAttribute('data-hide-filters')?.toLowerCase()?.split(',');
            let filter_label = filter.label.toLowerCase();
            if (!hideFilters.includes(filter_label)) {
                const filterOptions = Array.from(
                    document.getElementsByTagName("filter-option")
                );
                const matchedFilterOption = filterOptions.find(
                    (option) => option.getAttribute("filter-id") === filter.id
                );
    
                if (!matchedFilterOption) {
                    const filterOption = document.createElement("filter-option");
                    filterOption.setAttribute("filter-id", filter.id);
                    filterOption.setAttribute("filter-details", JSON.stringify(filter));
                    if (filter.id === 'filter.p.m.custom.styles') {
                        filterOption.classList.add('style_filter_option');
                    }
                    document
                        .querySelector(".collection-facets__filter-options")
                        .append(filterOption);
                } else {
                    if (filter.type === "LIST") {
                        filter.values.forEach((value) => {
                            const filterValuesWrapper = matchedFilterOption.querySelector(
                                ".filter-option__values"
                            );
                            const currentFilterValues = Array.from(
                                matchedFilterOption.querySelectorAll(
                                    ".filter-option__values label"
                                )
                            );
                            const isAlreadyInList = currentFilterValues.some(
                                (filterValue) =>
                                {
                                    return filterValue.dataset.value.toLowerCase() ===
                                    (filterValue.dataset.filterId === "filter.p.m.custom.fabric_type" ? (JSON.parse(value.input)?.productMetafield?.value?.toLowerCase()) : value.label.toLowerCase());
                                }
                            );
                            if (!isAlreadyInList) {
                                const filterValueLabel = Utils.getListFilterSwatch(filter, value);
                                filterValuesWrapper.append(filterValueLabel);
                            }
                        });
                    }
                }
            }
        });

        sortFiltersBySettings();

        if (document.querySelector('[data-new-collection-structure]')) {
            let selectedFilters = document.querySelectorAll('.collection-facets-wrapper .active:not(.sort-by-filters .active)');
            if (selectedFilters.length <= 0 ) {
                let clearAllBtns = document.querySelectorAll('.filter-clear-all:not(.hide-display)');
                if (clearAllBtns.length) {
                    clearAllBtns[0]?.click();
                }
            }
        }
    };

    const sortFiltersBySettings = () => {
        try {
            let allFilterOptions = Array.from(
                document.getElementsByTagName("filter-option")
            );

            if (filterSortingSettings && filterSortingSettings.length) {
                allFilterOptions.forEach((filterElement) => {
                    const filterLabelValue = filterElement.getAttribute("filter-label-value").toLowerCase();
                    let orderIndex = filterSortingSettings.findIndex(setting => filterLabelValue.includes(setting.toLowerCase()));
                    filterElement.style.order = orderIndex !== -1 ? orderIndex + 1 : 20;

                    let subFilterProcessedArray = processSubFilterSorting(subFilterSortingSettings);
                    const matchedKey = Object.keys(subFilterProcessedArray).find(
                        key => filterLabelValue.includes(key.toLowerCase())
                    );
                    const sortingOrder = matchedKey ? subFilterProcessedArray[matchedKey] : null;

                    if (sortingOrder) {
                        let allLabels = Array.from(filterElement.querySelectorAll("label.filter-checkbox"));

                        allLabels.forEach((labelElement) => {
                            let labelValue = labelElement.getAttribute("data-value")?.toLowerCase();
                            if (labelValue && labelValue.includes('/shopify')) {
                                labelValue = labelElement.getAttribute("title")?.toLowerCase();
                            }
                            let orderIndex = sortingOrder.findIndex(setting => labelValue.includes(setting.toLowerCase()));

                            labelElement.style.order = orderIndex !== -1 ? orderIndex + 1 : 30;
                        });
                    }
                });
            }
        }catch (e) {
            console.log('error from filter sorting')
        }
    }

    const processSubFilterSorting = (sortingArray) => {
        let sortingObject = {};

        sortingArray.forEach(entry => {
            let [mainFilter, subFilter] = entry.split(":").map(str => str.trim());

            if (!sortingObject[mainFilter]) {
                sortingObject[mainFilter] = [];
            }
            sortingObject[mainFilter].push(subFilter);
        });

        return sortingObject;
    };

    const createProductsCards = (collectionData, products) => {
        let productCardIndex = 0;
        let oldProductCardMiniBannerGap = 0;
        let productCardMiniBannerStep = 1;
        let productsLength = products.length;
        products.forEach((product) => {
            if (product?.node?.tags?.includes(window.globalVariables.hidden_tag)) {
                productsLength--;
                return;
            }

            if (window.globalVariables.woxer_only === 'true') {
                if (product?.node?.tags?.includes(window.globalVariables.woxer_only_product_tag)) {
                    productsLength--;
                    return;
                }
            }

            const productCard = document.createElement("product-card");
            // Save product information
            productCard.setAttribute(
                "product-url",
                `/products/${product.node.handle}`
            );

            let subscriptionOnlyTags = window.globalVariables.settings.subscription_only_tag.split(',');
            let subscriptionOnlyTagFound = false;
            subscriptionOnlyTags.forEach(subscriptionOnlyTag => {
                if (product?.node?.tags?.includes(subscriptionOnlyTag)) {
                    subscriptionOnlyTagFound = true;
                }
            })

            if (window.globalVariables.settings.enable_subscription_only && subscriptionOnlyTagFound) {
                productCard.classList.add('subscription-only')
            }
            productCard.setAttribute(
                "first-image-src",
                product.node.images.edges[0]?.node.url
            );
            productCard.setAttribute(
                "first-image-alt",
                product.node.images.edges[0]?.node.altText || ""
            );
            productCard.setAttribute(
                "second-image-src",
                product.node.images.edges[1]?.node.url
            );
            productCard.setAttribute(
                "second-image-alt",
                product.node.images.edges[1]?.node.altText || ""
            );
            productCard.setAttribute(
              "collection-style-group",
              product.node.collectionStyleGroup?.value || ""
            );

            productCard.setAttribute(
                "product-pack-size",
                product.node.packThumbnailTagNumber?.value || ""
              );

            productCard.setAttribute(
                "product-tags",
                product.node.tags?.join(",") || ""
            );

            productCard.setAttribute(
                "data-collection-product-card",
                ""
            )
            
            productCard.setAttribute('product-type', product.node.productType);
            productCard.setAttribute("product-id", product.node.id);
            productCard.setAttribute("product-details", JSON.stringify(product.node));
            productCard.setAttribute(
                "collection-data",
                JSON.stringify(collectionData)
            );

            const matchedCollectionElement = collectionsElements.find(
                (element) => element.dataset.handle === collectionData.collection.handle
            );
            productCard.style.order = productCardIndex.toString();
            matchedCollectionElement.append(productCard);
            productCardIndex++;

            if (productCardIndex % (4 * productCardMiniBannerStep) === 0) {
                let miniBannerEl = matchedCollectionElement.querySelector(`[data-collection-mini-banner-index="${productCardMiniBannerStep}"]`);
                if (miniBannerEl) {
                    if ((oldProductCardMiniBannerGap + productCardIndex - 1) >= productsLength) {
                        miniBannerEl.style.display = 'none';
                    }
                    else {
                        miniBannerEl.style.display = 'block';
                    }
                    miniBannerEl.style.order = (oldProductCardMiniBannerGap + productCardIndex).toString();
                    oldProductCardMiniBannerGap = (4 * productCardMiniBannerStep);
                    productCardMiniBannerStep++;
                }
            }
        });
    };

    const updateFilterQuery = () => {

        document.querySelector('.collection-product-wrapper')?.classList.add('d-none');
        document.querySelector('.collection-skeleton')?.classList.remove('d-none');

        const filtersDetails = {
            filters: [],
        };
        const filterQueryParams = Object.entries(Utils.getAllQueryParams());

        if (filterQueryParams.length === 0) {
            return "";
        }

        filterQueryParams.forEach((filterQueryParam) => {
            const queryParamName = filterQueryParam[0];
            const queryParamValues = filterQueryParam[1].split(",");

            if (queryParamName.includes("filter.v.option.")) {
                const optionName = queryParamName.replaceAll("filter.v.option.", "");
                const optionValues = queryParamValues;
                optionValues.forEach((value) => {
                    filtersDetails.filters.push({
                        variantOption: {
                            name: optionName,
                            value: value,
                        },
                    });
                });
            } else if (queryParamName.includes("filter.p.m.")) {
                const metafieldDetails = queryParamName.replaceAll("filter.p.m.", "");
                const metafieldValues = queryParamValues;
                const metafieldDetailsList = metafieldDetails.split(".");
                const metafieldNamespace = metafieldDetailsList[0];
                const metafieldKey = metafieldDetailsList[1];

                metafieldValues.forEach((value) => {
                    filtersDetails.filters.push({
                        productMetafield: {
                            namespace: metafieldNamespace,
                            key: metafieldKey,
                            value: value,
                        },
                    });
                });
            }
        });

        const minPrice = Utils.getQueryParam("filter.v.price.min");
        const maxPrice = Utils.getQueryParam("filter.v.price.max");

        if (minPrice && maxPrice) {
            filtersDetails.filters.push({
                price: {
                    min: minPrice,
                    max: maxPrice,
                },
            });
        }
        if (filtersDetails.filters.length > 0) {
            filtersDetails.filters.push({available: true})
        }

        return filtersDetails;
    };

    const afterRender = (allCollectionsData, renderFilterOptions) => {
        /* This function is used to render extra elements after the product collections and filters are rendered */
        let totalProducts = collectionsElements.reduce((acc, bundle) => {
            const productsCount = parseInt(
                bundle.getAttribute("data-products-count").length ? bundle.getAttribute("data-products-count") : '0'
            );
            return acc + productsCount;
        }, 0);

        const productsCountElement = document.querySelector(
            ".collections-bundles__product-count"
        );
        const firstValidElement = document.querySelector('.collection-bundle[data-products-count]:not([data-products-count="0"])');
        if (firstValidElement) {
            firstValidElement.classList.add('mt-0');
            firstValidElement.querySelector('.ab_seperator_new')?.classList?.add('mt-1');
        }
        if (document.querySelector('[data-new-collection-structure]')) {
            let wrapper = document.querySelector('.collection-product-wrapper .collection-bundle:not(.d-none)');
            let cardCount = wrapper?.querySelectorAll('product-card');
            if (cardCount) {
                totalProducts = cardCount.length;
            }
        }
        productsCountElement.innerText = `${totalProducts} ${
            totalProducts > 1 ? "products" : "product"
        }`;

        /*const mobileFilterProductsBtn = document.querySelector(
            ".filter-view-products"
        );
        mobileFilterProductsBtn.innerText =
            totalProducts > 0 ? `View Products (${totalProducts})` : "View Products";*/

        // Sort by extra elements
        Utils.updateSortingElements();

        // Init Price slider
        const minPriceParam = Utils.getQueryParam("filter.v.price.min");
        const maxPriceParam = Utils.getQueryParam("filter.v.price.max");
        let minPrice = 0;
        let minSelectedPrice = 0;
        let maxSelectedPrice = maxPrice;

        allCollectionsData.forEach((collection) => {
            const collectionPriceFilter = collection?.filters.find(
                (filter) => filter.id === "filter.v.price"
            );
            if (collectionPriceFilter) {
                const collectionPriceFilterDetails = JSON.parse(
                    collectionPriceFilter.values[0].input
                );
                if (collectionPriceFilterDetails.price.max > parseInt(maxPrice)) {
                    maxSelectedPrice = collectionPriceFilterDetails.price.max;
                    minSelectedPrice = collectionPriceFilterDetails.price.min;
                }
            }
        });

        if (minPriceParam && maxPriceParam) {
            maxSelectedPrice = parseFloat(maxPriceParam);
            minSelectedPrice = parseFloat(minPriceParam);
        }

        if (true || Object.entries(Utils.getAllQueryParams()).length === 0) {
            document.querySelectorAll('.collection-bundle').forEach(collectionBundle => {
                const maxCollectionPrice = parseFloat(collectionBundle.dataset.highestPrice);
                if (maxCollectionPrice > parseFloat(maxPrice)) {
                    maxPrice = maxCollectionPrice;
                }
            });

            if (!maxPriceParam) {
                maxSelectedPrice = maxPrice;
            }

            const priceSlider = document.getElementById("priceSlider");
            if(priceSlider && priceSlider.noUiSlider){
                priceSlider.noUiSlider.destroy();
            }
            if (priceSlider) {
                noUiSlider?.create(priceSlider, {
                    start: [minSelectedPrice, maxSelectedPrice],
                    connect: true,
                    behaviour: "drag",
                    range: {
                        min: minPrice,
                        max: maxPrice,
                    },
                    format: wNumb({
                        decimals: 0,
                        prefix: '$'
                    })
                });

                // Update slider labels
                priceSlider.noUiSlider.on('update', function (values, handle) {
                    if (handle === 0) {
                        document.querySelectorAll("[data-price-lower]").forEach(element => {
                            element.textContent = values[0];
                        });
                    } else {
                        document.querySelectorAll("[data-price-higher]").forEach(element => {
                            element.textContent = values[1];
                        });
                    }
                });

                priceSlider?.noUiSlider.on("end", function (event) {
                    // Pass null to render price-type filter
                    const minPrice = event[0].replace('$', '');
                    const maxPrice = event[1].replace('$', '');
                    Utils.setQueryParam("filter.v.price.min", minPrice);
                    Utils.setQueryParam("filter.v.price.max", maxPrice);
                });
            }
            
        }

        // refresh okendo reviews
        if (window.okeWidgetApi) {
            window.okeWidgetApi.initAllWidgets()
        }
        
        document.querySelector('.collection-product-wrapper')?.classList.remove('d-none');
        document.querySelector('.collection-product-wrapper').style.opacity = 0;
        setTimeout(function () {
            document.querySelector('.collection-product-wrapper').style.opacity = 1;
            document.querySelector('.collection-skeleton')?.classList.add('d-none');
        }, pageLoad == 0 || !Utils.isMobile() ? 250 : 1500)
        pageLoad = 0;
        
    };

    const showSpecificCollectionOnly = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const spCollection = urlParams.get('sp_collection');
        let newValue = '';
        if (spCollection) {
            newValue = spCollection;
        } else {
            let defaultElement = document.querySelector('.plp_new_structure_default [data-plp-new-structure-card]');
            if (defaultElement) {
                newValue = defaultElement.getAttribute('data-plp-new-structure-card');
            } else {
                let firstElement = document.querySelector('[data-plp-new-structure-card]');
                if (firstElement) {
                    newValue = firstElement.getAttribute('data-plp-new-structure-card');
                }
            }
        }
        setCardsForNewStructure(newValue);
        document.querySelectorAll('.collection-facets__filter-options .sort-by-filters')
            .forEach(ele => ele.classList.add('close'))
    }

    const setCardsForNewStructure = (newValue) => {
        let element = document.querySelector(`[data-plp-new-structure-card="${newValue}"]`)
        document.querySelectorAll('[data-plp-new-structure-products]').forEach(ele => ele.classList.add('d-none'));
        document.querySelector(`[data-plp-new-structure-products="${newValue}"]`)?.classList?.remove('d-none');
        const url = new URL(window.location.href);
        url.searchParams.set("sp_collection", newValue);
        history.pushState(null, null, url.toString());

        if (document.querySelector('[data-final-breadcrumb]')) {
            let breadTitle = element?.getAttribute('data-card-title')?.replace('All Underwear', '')?.replace('Shop All Bralettes & Tops', '')?.replace('Shop All Tops', '');
            if (breadTitle) {
                document.querySelectorAll('[data-final-breadcrumb]').forEach(ele => ele.innerHTML = breadTitle);
                document.querySelectorAll('.breadcrumb-wrapper .last-divider').forEach(ele => ele?.classList?.remove('d-none'));
            } else {
                document.querySelectorAll('[data-final-breadcrumb]').forEach(ele => ele.innerHTML = breadTitle);
                document.querySelectorAll('.breadcrumb-wrapper .last-divider').forEach(ele => ele?.classList?.add('d-none'));
            }
        }
        adjustBredcrumbs();
    }
    const scrollToElement=()=>{
         
        const target = window.location.href.includes('scrollto') ? Utils.getQueryParam('scrollto=') : false;
        if (target) {
            const element = document.querySelector(`#${target}`);
            if (element) {
                if (!Utility.in_Viewport(element)) {
                    setTimeout(() => {
                        document.querySelector(`[href="#${target}"]`).click();
                    }, 2500);
                }
            }
        }else if(pageLoad == 0){
            document.documentElement.style.scrollBehavior = 'auto';
            const element = document.querySelector('.collections-bundles-top');
            if (!Utility.in_Viewport(element)) {
                window.scrollTo({
                    top: element.offsetTop - 80,
                    left: 0
                });
            }
            setTimeout(() => {
                document.documentElement.style.scrollBehavior = 'smooth';
            }, 2000);
        }
    }

    const renderCollection = async (query, renderFilterOptions = true, onLoad = false) => {
        scrollToElement();
        if (onLoad && renderFilterOptions && document.querySelector('[data-new-collection-structure]')) {
            showSpecificCollectionOnly();
        }
        Utils.getOffers();

        removeAllElements(renderFilterOptions);

        if (!renderFilterOptions) {
            const currentQueryParams = Object.entries(Utils.getAllQueryParams());
            const filterSwatches = document.querySelectorAll('.filter-swatch,.filter-checkbox');
            filterSwatches.forEach(filterSwatch => {
                const isActiveSwatch = currentQueryParams.some(queryParam => {
                    const queryParamName = queryParam[0];
                    const queryParamValue = queryParam[1];
                    const currentParamValueArr = queryParamValue.split(",");
                    const filterSwatchId = filterSwatch.dataset.filterId;
                    const filterSwatchLabel = filterSwatchId === "filter.p.m.custom.fabric_type" ? filterSwatch.getAttribute('data-value') : filterSwatch.getAttribute('title');

                    return currentParamValueArr.includes(filterSwatchLabel) && queryParamName === filterSwatchId;
                });


                if (filterSwatch.closest('.filter-swatch')) {
                    if (isActiveSwatch) {
                        filterSwatch.classList.add("active");
                    } else {
                        filterSwatch.classList.remove("active");
                    }
                }else{
                    if (isActiveSwatch) {
                        filterSwatch.classList.add("active");
                        filterSwatch.querySelector('input').checked = true;
                    } else {
                        filterSwatch.classList.remove("active");
                        filterSwatch.querySelector('input').checked = false;
                    }
                }
            });
        }

        // Build filter bubbles

        // Reset bubbles
        Utils.resetFilterBubbles();
        const allQueryParams = Object.entries(Utils.getAllQueryParams());
        const filterBubblesWrappers = document.querySelectorAll(
            ".collection-facets__filter-bubbles"
        );
        let appliedFilters = 0;
        const MainCardSlider = document.querySelector('ul.collection-menu__items');
        const jumpLinkSlider = document.querySelector('.collection-sticky-menu ul');
        MainCardSlider.classList.add('opacity-0');
        jumpLinkSlider.classList.add('opacity-0');
        allQueryParams.forEach((queryParam) => {
            const queryParamName = queryParam[0];
            const queryParamValues = queryParam[1].split(",");
            const isRelevantParam =
                queryParamName.includes("filter.") &&
                !queryParamName.includes("filter.v.price");
            if (queryParam && isRelevantParam) {
                queryParamValues.forEach((queryParamValue) => {
                    filterBubblesWrappers.forEach((filterBubbleWrapper) => {
                        appliedFilters = appliedFilters + 1;
                        const bubbleElement = document.createElement("filter-bubble");
                        bubbleElement.dataset.label = queryParamValue;
                        bubbleElement.dataset.paramName = queryParamName;
                        filterBubbleWrapper.append(bubbleElement);
                    });
                });
            }
        });

        appliedFilters = appliedFilters / 2;

        if (Utils.getQueryParam('filter.v.price.max')) {
            appliedFilters = appliedFilters + 1;
            filterBubblesWrappers.forEach((filterBubbleWrapper) => {
                const bubbleElement = document.createElement("filter-bubble");
                const minPriceQuery = Utils.getQueryParam('filter.v.price.min');
                const maxPriceQuery = Utils.getQueryParam('filter.v.price.max');
                bubbleElement.dataset.label = `${Utils.formatMoney(minPriceQuery)} - ${Utils.formatMoney(maxPriceQuery)}`;
                bubbleElement.dataset.paramName = 'filter.v.price';
                filterBubbleWrapper.append(bubbleElement);
            });
        }

        // Hide/Show clear all buttons
        const filterQueryParams = Object.entries(Utils.getAllQueryParams()).filter(
            (param) => param[0].includes("filter.")
        );
        if (filterQueryParams.length > 0) {
            clearAllButtons.forEach((clearAllButton) =>
                clearAllButton.classList.remove("hide-display")
            );
            document.querySelector('.filter-mobile-toggle .applied-filters').innerText = '(' + appliedFilters + ')'
        } else {
            clearAllButtons.forEach((clearAllButton) =>
                clearAllButton.classList.add("hide-display")
            );
            document.querySelector('.filter-mobile-toggle .applied-filters').innerText = '';
        }

        const sortByValue = Utils.getQueryParam('sort_by');
        const sortByLabel = document.querySelector('.collections-bundles__sort-by-trigger span');
        if (sortByValue) {
            const newSortByLabel = Array.from(document.querySelectorAll('.sort-by-list button')).find(button => button.dataset.value === sortByValue);
            sortByLabel.innerText = `Sort by ${newSortByLabel.innerText.toLowerCase().replaceAll('radio button','')}`;
        } else {
            sortByLabel.innerText = 'Sort By Featured';
        }
        let handles=[];

        let collectionStyleGroupFilterValue = Utils.getQueryParam('filter.p.m.custom.collection_style_group');

        let allCollElements = collectionsElements;
        if (document.querySelector('[data-new-collection-structure]')) {
            allCollElements = Array.from(
                document.querySelectorAll(".collection-bundle:not(.d-none)")
            );
        }
        const allCollectionsData = await Promise.all(
            allCollElements.map(async (collection) => {
                const collectionHandle = collection.dataset.handle;
                let replacedQuery = query.replaceAll(
                    "{{collection_handle}}",
                    collectionHandle
                );
                const collectionData = collectionHandle && await useQuery(replacedQuery);

                if (!collectionData?.data?.collection) {
                    return {
                        edges:[],
                        filters: []
                    };
                }

                // if (
                //     // Temp fix for filter boss 2.0 products in collection
                //     collectionStyleGroupFilterValue
                //     && collectionStyleGroupFilterValue.includes('Boss 2.0')
                //     && !collectionHandle.includes('-boss')
                // ) {
                //     let tempCollectionProducts = [];
                //     collectionData.data.collection.products.edges.forEach((collectionProduct) => {
                //         if (!collectionProduct?.node?.collectionStyleGroup?.value?.includes('Boss 2.0')) {
                //             tempCollectionProducts.push(collectionProduct);
                //         }
                //     });
                //     collectionData.data.collection.products.edges = tempCollectionProducts;
                // }

                let productsLimit;
                const isMobile = Utils.isMobile();
                const isFiltered = window.location.href.includes('filter');
                const isClearanceCollection = collectionHandle && collectionHandle.includes('clearance-2024');

                if (isMobile) {
                    productsLimit = isFiltered
                        ? (isClearanceCollection ? parseInt(collection.dataset.productsLimitMobile) : 40)
                        : parseInt(collection.dataset.productsLimitMobile);
                } else {
                    productsLimit = isFiltered
                        ? (isClearanceCollection ? parseInt(collection.dataset.productsLimitDesktop) : 40)
                        : parseInt(collection.dataset.productsLimitDesktop);
                }

                let products = collectionData.data.collection.products.edges.splice(
                    0,
                    parseInt(productsLimit)
                );
                Utils.sortProducts(products);

                collection.dataset.productsCount = products.length;

                const collectionMenuHandle = collection.getAttribute('id');
                let collectionMenuElement = document.querySelector('.collection-menu__item a[href="#' + collectionMenuHandle + '"]')
                let collectionMenuElementV2 = document.querySelector('.collection-menu__item.collection-menu__item_v2 a[href="#' + collectionMenuHandle + '"]')
                let collectionStickyMenuElement = document.querySelector('.collection-menu__item-sticky a[href="#' + collectionMenuHandle + '"]')
                if (collectionMenuElement && collectionMenuElementV2 && !document.querySelector('[data-new-collection-structure]')) {
                    if (products.length === 0 && !window.location.href.includes('clearance-2024')) {
                        collectionMenuElement.parentElement.classList.add('d-none')
                        collectionStickyMenuElement.parentElement.classList.add('d-none')
                        collectionMenuElementV2.parentElement.classList.add('d-none')
                    } else {
                        collectionMenuElement.parentElement.classList.remove('d-none')
                        collectionStickyMenuElement.parentElement.classList.remove('d-none')
                        collectionMenuElementV2.parentElement.classList.remove('d-none')
                    }
                }

                let packFilters = document.querySelectorAll('.filter-option__values label[data-value="4 Pack"]:not(.disabled), ' +
                    '.filter-option__values label[data-value="6 Pack"]:not(.disabled), ' +
                    '.filter-option__values label[data-value="10 Pack"]:not(.disabled)');
                if (packFilters.length > 0) {
                    document.querySelectorAll('[data-pack-redirect-card]').forEach(ele => ele.classList.remove('d-none'));
                } else {
                    document.querySelectorAll('[data-pack-redirect-card]').forEach(ele => ele.classList.add('d-none'));
                }



                createProductsCards(collectionData.data, products);
                const productCards = collection.querySelectorAll("product-card");
                productCards.forEach((productCard)=>{
                    const productType = productCard.getAttribute('product-type');
                    const swatchCollectionHandle = Utils.handleize(productType)
                        .replace('baller-high-waisted', 'baller-highwaisted')
                        .replace('biker-high-waisted', 'biker-highwaisted')
                        .replace('baller-padliner', 'baller-pad-liner')
                        .replace('starhighwaisted-pack', 'star-high-waisted-pack')
                        .replace('ballerhighwaisted-pack', 'baller-high-waisted-pack')
                        .replace('bikerhighwaisted-pack', 'biker-high-waisted-pack')
                        .replace('tanktoprib-pack', 'tank-top-rib-pack')
                        .replace('ballerrib-pack', 'baller-rib-pack')
                        .replace('ballerflex-pack', 'baller-flex-pack')
                        .replace('bikerflex-pack', 'biker-flex-pack')
                        .replace('bossflex-pack', 'boss-flex-pack')
                        .replace('starflex-pack', 'star-flex-pack')
                        .replace('braletteluxe_pack', 'bralette-luxe-pack')
                        .replace('ballerluxe_pack', 'baller-luxe-pack')
                        .replace('ballerluxe-pack', 'baller-luxe-pack')
                        .replace('boldluxe_pack', 'bold-luxe-pack')
                        .replace('ballerpadliner-pack', 'baller-pad-liner-pack');
                    handles.push(swatchCollectionHandle)
                });
                if (renderFilterOptions && collectionData) {
                    createFilterOptions(collectionData.data.collection.products.filters);
                }
                return collectionData?.data.collection.products;
            })
        );

        let stickyElements = document.querySelectorAll('.collection-menu__item-sticky:not(.d-none)');
        if (stickyElements.length <= 3) {
            stickyElements[0]?.closest('ul')?.classList?.add('justify-content-center');
        } else {
            stickyElements[0]?.closest('ul')?.classList?.remove('justify-content-center');
        }
        if (jumpLinkSlider.scrollWidth > jumpLinkSlider.clientWidth) {
            jumpLinkSlider.classList.remove('justify-content-center');
            jumpLinkSlider.classList.add('justify-content-start');
        } else {
            jumpLinkSlider.classList.remove('justify-content-start');
            jumpLinkSlider.classList.add('justify-content-center');
        }

        //
        // let stickyElementsCards = document.querySelectorAll('.collection-header .collection-menu__items .collection-menu__item.collection-menu__item_v2:not(.d-none)');
        // let stickyElementsCardWrapper = document.querySelector('.collection-header .collection-menu__items');
        // if (stickyElementsCards.length <= 4) {
        //     stickyElementsCardWrapper?.classList?.add('justify-content-md-center');
        //     stickyElementsCardWrapper?.classList?.remove('justify-content-md-start');
        // } else {
        //     stickyElementsCardWrapper?.classList?.remove('justify-content-md-center');
        //     stickyElementsCardWrapper?.classList?.add('justify-content-md-start');
        // }
        MainCardSlider.classList.remove('opacity-0');
        jumpLinkSlider.classList.remove('opacity-0');

        Utils.updateFilterOptions();
        
        document.querySelectorAll('[data-filter-id]').forEach((ele)=>{
            ele.classList.add('disabled');
        });
        
        allCollectionsData.forEach((collData)=>{
            collData.filters.forEach((filter)=>{
                let id = filter.id;
                filter.values.forEach((val)=>{
                    if (val.count > 0) {
                        document.querySelector(`[data-filter-id='${id}'][data-value='${id === 'filter.p.m.custom.fabric_type' ? (JSON.parse(val.input))?.productMetafield?.value : val.label}']`)?.classList.remove('disabled');
                    }
                })
            })
        })
        
        afterRender(allCollectionsData, renderFilterOptions);
        handles=[...new Set(handles)];
        let swatchesData={};

        await Promise.all(
            handles.map(async (handle,index) => {
                swatchesData[handle] = await useQuery(getSwatchCollectionQuery().replaceAll("{{collection_handle}}", handle));
            })
        )
        let settings = window.globalVariables.settings;
        let enableComingSoon = settings.enable_coming_soon;
        let comingSoonProductTag = settings.coming_soon_product_tag;

        let enableNewRelease = settings.enable_new_release;
        let newReleaseSinglesProductTag = settings.new_release_singles_product_tag;
        let newReleasePacksProductTag = settings.new_release_packs_product_tag;

        const allSwatchesData = await Promise.all(
            collectionsElements.map(async (collection) => {
                const productCards = collection.querySelectorAll("product-card");
                productCards.forEach(async (productCard) => {
                    // Build color swatches
                    const productId = productCard.getAttribute("product-id");
                    const productURL = productCard.getAttribute("product-url");
                    const productType = productCard.getAttribute('product-type');
                    const productTags = productCard.getAttribute('product-tags');
                    let productPackSize = productCard.getAttribute('product-pack-size');
                    let collectionStyleGroup = productCard.getAttribute('collection-style-group');

                    productPackSize = productPackSize.length !== 0 ? productPackSize : false

                    let swatchCollectionHandle = productType === 'mix_pack'
                      ? 'mixpack'
                      : Utils.handleize(productType)
                          .replace('baller-high-waisted', 'baller-highwaisted')
                          .replace('biker-high-waisted', 'biker-highwaisted')
                          .replace('baller-padliner', 'baller-pad-liner')
                          .replace('starhighwaisted-pack', 'star-high-waisted-pack')
                          .replace('ballerhighwaisted-pack', 'baller-high-waisted-pack')
                          .replace('bikerhighwaisted-pack', 'biker-high-waisted-pack')
                          .replace('tanktoprib-pack', 'tank-top-rib-pack')
                          .replace('ballerrib-pack', 'baller-rib-pack')
                          .replace('ballerflex-pack', 'baller-flex-pack')
                          .replace('bikerflex-pack', 'biker-flex-pack')
                          .replace('bossflex-pack', 'boss-flex-pack')
                          .replace('starflex-pack', 'star-flex-pack')
                          .replace('braletteluxe_pack', 'bralette-luxe-pack')
                          .replace('ballerluxe_pack', 'baller-luxe-pack')
                          .replace('ballerluxe-pack', 'baller-luxe-pack')
                          .replace('boldluxe_pack', 'bold-luxe-pack')
                          .replace('ballerpadliner-pack', 'baller-pad-liner-pack');

                    if (productURL.includes('vip') && swatchCollectionHandle !== 'mixpack') {
                      swatchCollectionHandle = `${swatchCollectionHandle}-vip`
                    }

                    if (enableComingSoon && comingSoonProductTag.length > 0 && productTags.includes(comingSoonProductTag)) {
                        swatchCollectionHandle = `${swatchCollectionHandle}-coming-soon`
                    }

                    if (enableNewRelease && newReleaseSinglesProductTag.length && productTags.includes(newReleaseSinglesProductTag)) {
                        swatchCollectionHandle = `${swatchCollectionHandle}-clearance`
                        swatchCollectionHandle = swatchCollectionHandle.replace('ballerfly', 'baller-fly-')
                    }

                    let siblingProductsData = {};
                    if (swatchesData[swatchCollectionHandle]) {
                        siblingProductsData = swatchesData[swatchCollectionHandle]
                        let otherSiblingProductsData = await useQuery(PRODUCT_SWATCHES_QUERY.replaceAll("{{collection_handle}}", swatchCollectionHandle));

                        if (siblingProductsData) {
                            const siblingProductIds = new Set(siblingProductsData.data.collection.products.edges.map(p => p.node.id));

                            // Filter otherSiblingProductsData to remove duplicate products that are already in siblingProductsData
                            const filteredOtherSiblings = otherSiblingProductsData.data.collection.products.edges.filter(p => !siblingProductIds.has(p.node.id));

                            // Combine siblingProductsData first, then append filtered otherSiblingProductsData
                            const mergedProducts = [
                                ...siblingProductsData.data.collection.products.edges,
                                ...filteredOtherSiblings
                            ];
                            siblingProductsData.data.collection.products.edges = mergedProducts
                        }
                    }else{
                        siblingProductsData = await useQuery(PRODUCT_SWATCHES_QUERY.replaceAll("{{collection_handle}}", swatchCollectionHandle));
                    }
                    if (siblingProductsData.data.collection) {
                        let siblingProducts = siblingProductsData.data.collection.products.edges;


                        /* -------------- filter pack products ---------------- */
                        siblingProducts = siblingProducts.filter(siblingProduct => {
                            return productPackSize && siblingProduct.node.tags.includes('PACK')
                            ? siblingProduct.node.tags.includes(productPackSize + 'PACK')
                            : siblingProduct
                        })

                        siblingProducts = siblingProducts.filter(siblingProduct => {
                            return swatchCollectionHandle.includes('pack') === false
                              ? siblingProduct.node.tags.includes('WSINGLES')
                              : siblingProduct
                        })

                        siblingProducts = siblingProducts.filter(siblingProduct => {
                            return swatchCollectionHandle.includes('mixpack')
                              ? siblingProduct.node.collectionStyleGroup.value == collectionStyleGroup
                              : siblingProduct
                        })

                        if (enableNewRelease && newReleasePacksProductTag) {
                            siblingProducts = siblingProducts.filter(siblingProduct => {
                                return productTags.includes(newReleasePacksProductTag)
                                  ? siblingProduct.node.tags.includes(newReleasePacksProductTag)
                                  : !siblingProduct.node.tags.includes(newReleasePacksProductTag)
                            })
                        }

                        Utils.sortProducts(siblingProducts);

                        let slicedSiblingProducts;

                        // Sort the array
                        siblingProducts.sort((a, b) => {
                            if (a.node.id === productId) return -1; // "a" comes first
                            if (b.node.id === productId) return 1; // "b" comes first
                            return 0; // No change in order
                        });
                        let tempFilteredProducts = siblingProducts.filter(function(product) {
                            return product?.node?.tags?.includes(window.globalVariables.hidden_tag) == false;
                        });

                        if (window.globalVariables.woxer_only === 'true') {
                            tempFilteredProducts = siblingProducts.filter(function(product) {
                                return product?.node?.tags?.includes(window.globalVariables.woxer_only_product_tag) == false;
                            });
                        }

                        let blackFound = false;
                        let blackProducts = [];
                        let filteredProducts = tempFilteredProducts.filter(product => {
                            if (product.node.title.toLowerCase().includes('black')) {
                                if (!blackFound) {
                                    blackFound = true;
                                    return true; // Keep the first black product
                                } else {
                                    blackProducts.push(product); // Collect subsequent black products
                                    return false; // Temporarily remove subsequent black products from the filtered list
                                }
                            }
                            return true; // Keep non-black products
                        });

                        // Now combine the non-black products with the black products at the end
                        filteredProducts = filteredProducts.concat(blackProducts);
                        siblingProducts=filteredProducts;

                        if (Utils.isMobile()) {
                            slicedSiblingProducts = siblingProducts.slice(0, 5);
                        } else {
                            slicedSiblingProducts = siblingProducts.slice(0, 6);
                        }

                        const colorSwatchesWrapper = productCard.querySelector(
                            ".product-card__swatches"
                        );
                        colorSwatchesWrapper.innerHTML="";
                        slicedSiblingProducts.forEach((siblingProduct) => {
                            let swatchImage = '';
                            if (siblingProduct.node.packIcon) {
                                swatchImage = siblingProduct.node.packIcon.reference.image.url;
                            }
                            else if (siblingProduct.node.featuredImage) {
                                swatchImage = siblingProduct.node.featuredImage.url;
                            }

                            let swatchImage2 = '';
                            if (siblingProduct.node.packIcon) {
                                swatchImage2 = siblingProduct.node.packIcon.reference.image.url;
                            }
                            else if (siblingProduct.node.featuredImage) {
                                swatchImage2 = siblingProduct.node.featuredImage.url;
                            }

                            const colorSwatch = document.createElement(
                                "product-color-swatch"
                            );
                            colorSwatch.setAttribute(
                                "sibling-product-details",
                                JSON.stringify(siblingProduct)
                            );

                            colorSwatch.setAttribute('swatch-image', swatchImage);
                            colorSwatch.setAttribute('swatch-image-2', swatchImage2);
                            colorSwatch.setAttribute("product-card-id", productId);
                            colorSwatchesWrapper.append(colorSwatch);
                        });

                        if (siblingProducts.length > (Utils.isMobile() ? 5 : 6)) {
                            const plusSwatchesElement = document.createElement("a");
                            plusSwatchesElement.href = productURL;
                            plusSwatchesElement.classList.add("product-card__swatches-plus");
                            plusSwatchesElement.setAttribute('quick_add_swatches', `${siblingProducts.length - 19}`)
                            plusSwatchesElement.innerText = `+${siblingProducts.length - (Utils.isMobile() ? 5 : 6)}`;
                            colorSwatchesWrapper.append(plusSwatchesElement);
                        }

                        productCard.setAttribute(
                            "data-sibling-products-details",
                            JSON.stringify(siblingProductsData.data.collection.products.edges)
                        );
                    }
                });

                if (renderFilterOptions && typeof collectionData !== 'undefined' && collectionData) {
                    createFilterOptions(collectionData.data.collection.products.filters);
                }
                return collectionData?.data.collection.products;
            })
        );
        
        afterRender(allSwatchesData, renderFilterOptions);
    };

    const getCollectionQuery = () => {
        const filtersDetails = updateFilterQuery();

        
        // Temp boss 2.0 fix
        let filtersString = JSON.stringify(filtersDetails);
        filtersString = filtersString.replaceAll("Boss 2.0", "Boss 2.x");
        filtersString = filtersString.replaceAll("Icon 2.0", "Icon 2.x");

        filtersString = Utils.formatFilterQuery(filtersString);

        filtersString = filtersString.replaceAll("Boss 2.x", "Boss 2.0");
        filtersString = filtersString.replaceAll("Icon 2.x", "Icon 2.0");

        

        let query;
        if (filtersString !== '""' && filtersString !== "filters:{}}") {
            query = FILTER_PRODUCTS_QUERY.replaceAll(
                "{{filters_details}}",
                filtersString
            );
        } else {
            query = ALL_PRODUCTS_COLLECTION_QUERY;
        }

        // Set SortKey
        const sortByValue = Utils.getQueryParam("sort_by");
        const sortByQueryDictionary = {
            manual: "MANUAL",
            "best-selling": "BEST_SELLING",
            title: "TITLE",
            price: "PRICE",
        };
        if (sortByValue) {
            query = query.replaceAll(
                "{{sort_key}}",
                sortByQueryDictionary[sortByValue]
            );
        } else {
            query = query.replaceAll("{{sort_key}}", "COLLECTION_DEFAULT");
        }
        return query;
    };

    const getSwatchCollectionQuery = () => {
        const filtersDetails = {
            filters: [],
        };
        const filterQueryParams = Object.entries(Utils.getAllQueryParams());

        if (filterQueryParams.length === 0) {
            return PRODUCT_SWATCHES_QUERY
        }

        filterQueryParams.forEach((filterQueryParam) => {
            const queryParamName = filterQueryParam[0];
            const queryParamValues = filterQueryParam[1].split(",");

            if (queryParamName.includes("filter.v.option.")) {
                const optionName = queryParamName.replaceAll("filter.v.option.", "");
                const optionValues = queryParamValues;
                optionValues.forEach((value) => {
                    filtersDetails.filters.push({
                        variantOption: {
                            name: optionName,
                            value: value,
                        },
                    });
                });
            } else if (queryParamName.includes("filter.p.m.")) {
                const metafieldDetails = queryParamName.replaceAll("filter.p.m.", "");
                const metafieldValues = queryParamValues;
                const metafieldDetailsList = metafieldDetails.split(".");
                const metafieldNamespace = metafieldDetailsList[0];
                const metafieldKey = metafieldDetailsList[1];

                metafieldValues.forEach((value) => {
                    filtersDetails.filters.push({
                        productMetafield: {
                            namespace: metafieldNamespace,
                            key: metafieldKey,
                            value: value,
                        },
                    });
                });
            }
        });

        const minPrice = Utils.getQueryParam("filter.v.price.min");
        const maxPrice = Utils.getQueryParam("filter.v.price.max");

        if (minPrice && maxPrice) {
            filtersDetails.filters.push({
                price: {
                    min: minPrice,
                    max: maxPrice,
                },
            });
        }
        filtersDetails.filters.push({available: true})
        // Temp boss 2.0 fix
        let filtersString = JSON.stringify(filtersDetails);
        filtersString = filtersString.replaceAll("Boss 2.0", "Boss 2.x");
        filtersString = filtersString.replaceAll("Icon 2.0", "Icon 2.x");

        filtersString = Utils.formatFilterQuery(filtersString);

        filtersString = filtersString.replaceAll("Boss 2.x", "Boss 2.0");
        filtersString = filtersString.replaceAll("Icon 2.x", "Icon 2.0");

        let query;
        if (filtersString !== '""' && filtersString !== "filters:{}}") {
            query = PRODUCT_FILTER_SWATCHES_QUERY.replaceAll(
                "{{filters_details}}",
                filtersString
            );
            // query = PRODUCT_SWATCHES_QUERY;
        } else {
            query = PRODUCT_SWATCHES_QUERY;
        }

        // Set SortKey
        const sortByValue = Utils.getQueryParam("sort_by");
        const sortByQueryDictionary = {
            manual: "MANUAL",
            "best-selling": "BEST_SELLING",
            title: "TITLE",
            price: "PRICE",
        };
        if (sortByValue) {
            query = query.replaceAll(
                "{{sort_key}}",
                sortByQueryDictionary[sortByValue]
            );
        } else {
            query = query.replaceAll("{{sort_key}}", "COLLECTION_DEFAULT");
        }
        return query;
    };

    renderCollection(getCollectionQuery(), true, true);

    window.addEventListener("paramchange", async () => {
        renderCollection(getCollectionQuery(), false);
    });

    // Theme editor JS events
    if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', (event) => {
            renderCollection(ALL_PRODUCTS_COLLECTION_QUERY);
        });
    }

    let lastScrollTop = 0;
    window.addEventListener("scroll", () => {
        // Sticky menu
        const isHeaderVisible = Utils.isInViewport(
            document.querySelector(".collection-header"),
            1
        );

        let isBannerVisible = false
        const heroImageContainer = document.querySelector(".collection-hero__image-container");
        if (heroImageContainer !== null) {
            isBannerVisible = Utils.isInViewport(heroImageContainer, 1);
        }
        const stickyMenu = document.querySelector(".collection-sticky-menu");
        const collectionFacetsWrapper = document.querySelector(
            ".collection-facets-wrapper"
        );

        //to handle arrow below filter if overflow
        try {
            let moreFilterArrow = document.querySelector('.collection-product-list .filter_scroll_down');
            if (moreFilterArrow && !Utils.isMobile()) {
                if (isScrollableVertically(collectionFacetsWrapper)) {
                    moreFilterArrow?.classList?.add('d-none');
                } else {
                    moreFilterArrow?.classList?.add('d-none');
                }

                let mainContainer = document.querySelector('.collection-product-list');
                const col1Bottom = collectionFacetsWrapper.getBoundingClientRect().bottom;
                const containerTop = mainContainer.getBoundingClientRect().top;
                const offsetTop = col1Bottom - containerTop + 5;
                moreFilterArrow.style.opacity = '0';
                setTimeout(() => {moreFilterArrow.style.opacity = '1';}, 250);
                moreFilterArrow.style.top = `${offsetTop}px`;
                moreFilterArrow.style.bottom = `unset`;
            }

        } catch (e) {
            console.log(e)
        }


        const filterHeader = document.querySelector(".collections-bundles-top");
        let firstDescriptionVisible = false
        const firstDescription = document.querySelector('.category-separator-description');
        if (firstDescription !== null) {
            firstDescriptionVisible = Utils.isInViewport(firstDescription, 1);
        }
        const collectionsBundlesWrapper = document.querySelector(".collections-bundles-wrapper");
        let filterHeaderTopSpace = (document.querySelector('sticky-header .site-header')?.offsetHeight || 78) + (document.querySelector('.collection-sticky-menu:not(.visibility-hidden)')?.offsetHeight || -4);
        if (isHeaderVisible || isBannerVisible || firstDescriptionVisible) {
            collectionsBundlesWrapper.style.marginTop = '0px';
            if (filterHeader) {
                filterHeader.classList.remove('sticky-filter');
            }
            collectionFacetsWrapper.classList.remove("sticky");
            
            stickyMenu?.classList.remove('show');
            // stickyMenu.style.display = "none";
            document.querySelector('sticky-header nav')?.classList.add('shadow');
        } else {
            stickyMenu?.classList.add('show');
            // stickyMenu.style.display = "block";
            document.querySelector('sticky-header nav')?.classList.remove('shadow');
            collectionFacetsWrapper.classList.add("sticky");
            if (filterHeader) {
                filterHeader.style.top = (filterHeaderTopSpace-4) + 'px'
            }
            const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
            let footerMessage = document.querySelector('.shipping-band-message-container');

            if (!Utility.in_Viewport(document.querySelector('.footer-newsletter'))
                && Utility.in_Viewport(document.querySelector('.collection-sticky-menu'))
                && !Utility.in_Viewport(footerMessage)) {
                if (currentScrollTop > lastScrollTop) {
                    filterHeader.style.top = '0px';
                    setTimeout(() => {
                        collectionsBundlesWrapper.style.marginTop = '0px';
                        filterHeader.classList.remove('sticky-filter');
                    }, 200);
                } else {
                    collectionsBundlesWrapper.style.marginTop = '50px';
                    filterHeader.classList.add('sticky-filter');
                }
    
                lastScrollTop = currentScrollTop;
            }
        }

        collectionsElements.forEach((collectionElement) => {
            if (collectionElement.querySelector('[data-collection-product-card]') && collectionElement.querySelector('[data-collection-product-card]') !== null) {
                const isCollectionVisible = Utils.isInViewport(collectionElement, 1);
                if (isCollectionVisible && !window.defaultScrollEffect) {
                    const matchedStickyItem = document.querySelector(
                        `.collection-menu__item-sticky[data-handle="${collectionElement.dataset.handle}"]:not(.redirect)`
                    );
                    document
                        .querySelectorAll(".collection-menu__item-sticky")
                        .forEach((stickyItem) => stickyItem.classList.remove("active"));
                    matchedStickyItem?.classList.add("active");
                    var rect = matchedStickyItem?.getBoundingClientRect();
                    var firstElementRect = document.querySelector('.collection-menu__item-sticky').getBoundingClientRect();
                    if (matchedStickyItem && !isFullyVisible(matchedStickyItem)) {
                        document.querySelector('.collection-sticky-menu ul').scrollLeft=rect.left - firstElementRect.left;
                    }
                }
            }
        });
    });
})();

function isFullyVisible(element) {
    var rect = element.getBoundingClientRect();
    // Check if all edges of the element are within the viewport
    var isCompletelyVisible =
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth);

    return isCompletelyVisible;
}

function isScrollableVertically(container) {
    return container.scrollHeight > container.clientHeight;
}


function adjustBredcrumbs() {
    const breadcrumbWrapper = document.querySelector(".breadcrumb-wrapper");
    if (breadcrumbWrapper) {
        const breadcrumbs = breadcrumbWrapper.querySelectorAll("a, span[data-final-breadcrumb]");
        if (breadcrumbs.length >= 2) {
            const lastBreadcrumb = breadcrumbs[breadcrumbs.length - 1];
            let secondLastBreadcrumb = breadcrumbs[breadcrumbs.length - 2];

            // Remove trailing slash (if any) from second last breadcrumb text
            let secondLastBreadcrumbText = secondLastBreadcrumb.textContent.trim().replace(/\/$/, '').trim();
            let lastBreadcrumbText = lastBreadcrumb.textContent.trim();

            if (lastBreadcrumbText === secondLastBreadcrumbText) {
                lastBreadcrumb.remove();
                // Also remove the last slash if it exists
                let lastSeparator = secondLastBreadcrumb.querySelector('[data-breadcrumb-separator]');
                if (lastSeparator) {
                    lastSeparator.remove();
                }
            }
        }
    }
}



function adjustMarging() {
    var collectionMenuItemEle = document.querySelector('.collection-menu__items');
    var collectionProductListEle = document.querySelector('.collection-product-list');
    if (collectionMenuItemEle && collectionProductListEle) {
        const collectionMenuItemEleMarginValues = Utility.getMarginValues(collectionProductListEle);
        if (collectionMenuItemEleMarginValues?.left > 0) {
            
        }
        collectionMenuItemEle.style.marginLeft = (collectionMenuItemEleMarginValues?.left || 0) + 'px';
    }
}
if (document.querySelector('.plp_new_structure')) {
    adjustMarging();
    window.addEventListener('resize',()=>{
        adjustMarging();
    })
}